import { Routes } from '@angular/router';
import { authGuard } from './core/auth/auth.guard';
import { permissionGuard } from './core/auth/permission.guard';
import { scopeGuard } from './core/auth/scope.guard';
import { wizardGateGuard } from './features/wizards/wizard-gate.guard';
import { WizardRunHostComponent } from './features/wizards/wizard-run-host.component';
import { CatalogComponent } from './features/catalog/catalog.component';
import { CatalogOfferingDetailComponent } from './features/catalog/catalog-offering-detail.component';
import { CatalogProductsHubComponent } from './features/catalog/catalog-products-hub.component';
import { InventoryMovementDetailComponent } from './features/catalog/inventory-movement-detail.component';
import { InventoryMovementsComponent } from './features/catalog/inventory-movements.component';
import { InventoryCountSessionsComponent } from './features/catalog/inventory-count-sessions.component';
import { InventoryInboundShipmentsComponent } from './features/catalog/inventory-inbound-shipments.component';
import { InventoryInboundShipmentDetailComponent } from './features/catalog/inventory-inbound-shipment-detail.component';
import { InventoryRequisitionsComponent } from './features/catalog/inventory-requisitions.component';
import { InventoryRequisitionDetailComponent } from './features/catalog/inventory-requisition-detail.component';
import { InventorySupplyOrderDetailComponent } from './features/catalog/inventory-supply-order-detail.component';
import { InventoryReplenishmentPoliciesComponent } from './features/catalog/inventory-replenishment-policies.component';
import { InventoryReplenishmentPolicyDetailComponent } from './features/catalog/inventory-replenishment-policy-detail.component';
import { InventoryReplenishmentBreachesComponent } from './features/catalog/inventory-replenishment-breaches.component';
import { InventoryExpiryStatusComponent } from './features/catalog/inventory-expiry-status.component';
import { InventoryOfficialReportsHubComponent } from './features/catalog/inventory-official-reports-hub.component';
import { InventoryReservationsComponent } from './features/catalog/inventory-reservations.component';
import { InventoryPickWavesComponent } from './features/catalog/inventory-pick-waves.component';
import { InventoryPickWaveDetailComponent } from './features/catalog/inventory-pick-wave-detail.component';
import { InventoryWarehouseTasksComponent } from './features/catalog/inventory-warehouse-tasks.component';
import { InventoryOutboundShipmentsComponent } from './features/catalog/inventory-outbound-shipments.component';
import { InventoryCarrierWebhookEventsComponent } from './features/catalog/inventory-carrier-webhook-events.component';
import { InventoryOperatorComponent } from './features/catalog/inventory-operator.component';
import { InventoryKpiDashboardComponent } from './features/catalog/inventory-kpi-dashboard.component';
import { InventoryInternalConsumptionComponent } from './features/catalog/inventory-internal-consumption.component';
import { InventoryWarehouseDetailV2Component } from './features/catalog/inventory-warehouse-detail-v2.component';
import { InventoryWarehousesComponent } from './features/catalog/inventory-warehouses.component';
import { InventoryLotsComponent } from './features/catalog/inventory-lots.component';
import { InventoryLotDetailComponent } from './features/catalog/inventory-lot-detail.component';
import { InventorySerialsComponent } from './features/catalog/inventory-serials.component';
import { InventorySerialDetailComponent } from './features/catalog/inventory-serial-detail.component';
import { InventoryQcInspectionsComponent } from './features/catalog/inventory-qc-inspections.component';
import { InventoryQcInspectionDetailComponent } from './features/catalog/inventory-qc-inspection-detail.component';
import { InventoryRecallDetailComponent } from './features/catalog/inventory-recall-detail.component';
import { InventoryRecallsComponent } from './features/catalog/inventory-recalls.component';
import { ServiceOrdersComponent } from './features/catalog/service-orders.component';
import { ServiceOrderDetailComponent } from './features/catalog/service-order-detail.component';
import { ServiceResourcesComponent } from './features/catalog/service-resources.component';
import { RmaRequestsComponent } from './features/catalog/rma-requests.component';
import { RmaRequestDetailComponent } from './features/catalog/rma-request-detail.component';
import { OperationsControlRoomComponent } from './features/catalog/operations-control-room.component';
import { InventoryTrackingDashboardComponent } from './features/catalog/inventory-tracking-dashboard.component';
import { ServiceDispatchBoardComponent } from './features/catalog/service-dispatch-board.component';
import { TechnicianWorkQueueComponent } from './features/catalog/technician-work-queue.component';
import { InventoryTraceabilityComponent } from './features/catalog/inventory-traceability.component';
import { InventoryCostingPoliciesComponent } from './features/catalog/inventory-costing-policies.component';
import { InventoryCostingPolicyDetailComponent } from './features/catalog/inventory-costing-policy-detail.component';
import { InventoryValuationComponent } from './features/catalog/inventory-valuation.component';
import { InventoryValuationSnapshotComponent } from './features/catalog/inventory-valuation-snapshot.component';
import { InventoryCostLayersComponent } from './features/catalog/inventory-cost-layers.component';
import { InventoryCostLayerDetailComponent } from './features/catalog/inventory-cost-layer-detail.component';
import { InventoryRevaluationsComponent } from './features/catalog/inventory-revaluations.component';
import { InventoryRevaluationDetailComponent } from './features/catalog/inventory-revaluation-detail.component';
import { InventoryOperabilityComponent } from './features/catalog/inventory-operability.component';
import { AssetRegisterComponent } from './features/catalog/asset-register.component';
import { AssetDetailComponent } from './features/catalog/asset-detail.component';
import { RentalAgreementsComponent } from './features/catalog/rental-agreements.component';
import { RentalAgreementDetailComponent } from './features/catalog/rental-agreement-detail.component';
import { CmmsWorkOrdersComponent } from './features/catalog/cmms-work-orders.component';
import { CmmsWorkOrderDetailComponent } from './features/catalog/cmms-work-order-detail.component';
import { CmmsDowntimeDashboardComponent } from './features/catalog/cmms-downtime-dashboard.component';
import { RentalBookingBoardComponent } from './features/catalog/rental-booking-board.component';
import { HospitalityPropertiesComponent } from './features/catalog/hospitality-properties.component';
import { HospitalityPropertyDetailComponent } from './features/catalog/hospitality-property-detail.component';
import { HospitalityReservationsComponent } from './features/catalog/hospitality-reservations.component';
import { HospitalityReservationDetailComponent } from './features/catalog/hospitality-reservation-detail.component';
import { HospitalityHousekeepingComponent } from './features/catalog/hospitality-housekeeping.component';
import { HospitalityRateCalendarComponent } from './features/catalog/hospitality-rate-calendar.component';
import { HospitalityFrontDeskComponent } from './features/catalog/hospitality-front-desk.component';
import { HospitalityKpiDashboardComponent } from './features/catalog/hospitality-kpi-dashboard.component';
import { HospitalityPolicyExceptionsComponent } from './features/catalog/hospitality-policy-exceptions.component';
import { HospitalityBookingBoardComponent } from './features/catalog/hospitality-booking-board.component';
import { HospitalityRoomMaintenanceComponent } from './features/catalog/hospitality-room-maintenance.component';
import { DigitalEntitlementsComponent } from './features/catalog/digital-entitlements.component';
import { DigitalEntitlementDetailComponent } from './features/catalog/digital-entitlement-detail.component';
import { RegulatedFinanceCockpitComponent } from './features/catalog/regulated-finance-cockpit.component';
import { UnifiedCommerceOrdersComponent } from './features/catalog/unified-commerce-orders.component';
import { SubscriptionContractsComponent } from './features/catalog/subscription-contracts.component';
import { SubscriptionContractDetailComponent } from './features/catalog/subscription-contract-detail.component';
import { CommercialAddonsComponent } from './features/commercial/commercial-addons.component';
import { CommercialModulesComponent } from './features/commercial/commercial-modules.component';
import { CommercialPlansComponent } from './features/commercial/commercial-plans.component';
import { MarketplaceIndustrySolutionsComponent } from './features/commercial/marketplace-industry-solutions.component';
import { MarketplaceDashboardComponent } from './features/catalog/marketplace-dashboard.component';
import { MarketplaceLaunchReadinessComponent } from './features/catalog/marketplace-launch-readiness.component';
import { GlobalCommerceAdminComponent } from './features/catalog/global-commerce-admin.component';
import { MarketplaceOptimizationAdminComponent } from './features/catalog/marketplace-optimization-admin.component';
import { MarketplaceSellerDetailComponent } from './features/catalog/marketplace-seller-detail.component';
import { MarketplaceCommissionRulesComponent } from './features/catalog/marketplace-commission-rules.component';
import { MarketplaceSellerTiersComponent } from './features/catalog/marketplace-seller-tiers.component';
import { MarketplaceRetailMediaComponent } from './features/catalog/marketplace-retail-media.component';
import { MarketplaceSellersComponent } from './features/catalog/marketplace-sellers.component';
import { MarketplaceOfferingProposalsComponent } from './features/catalog/marketplace-offering-proposals.component';
import { StorefrontStoreManagerComponent } from './features/catalog/storefront-store-manager.component';
import { StorefrontPublishingComponent } from './features/catalog/storefront-publishing.component';
import { StorefrontCategoryNavigationManagerComponent } from './features/catalog/storefront-category-navigation-manager.component';
import { StorefrontHomeComposerComponent } from './features/catalog/storefront-home-composer.component';
import { StorefrontContentBlockManagerComponent } from './features/catalog/storefront-content-block-manager.component';
import { CmmsMaintenancePlansComponent } from './features/catalog/cmms-maintenance-plans.component';
import { DashboardComponent } from './features/dashboard.component';
import { DynamicImportExportComponent } from './features/dynamic/dynamic-import-export.component';
import { DynamicAuditComponent } from './features/dynamic/dynamic-audit.component';
import { DynamicAnalyticsDashboardComponent } from './features/dynamic/dynamic-analytics-dashboard.component';
import { StorefrontFormCatalogComponent } from './features/dynamic/storefront-form-catalog.component';
import { DynamicEntitiesComponent } from './features/dynamic/dynamic-entities.component';
import { DynamicEntityDetailComponent } from './features/dynamic/dynamic-entity-detail.component';
import { DynamicFormDetailComponent } from './features/dynamic/dynamic-form-detail.component';
import { DynamicFormSubmissionDetailComponent } from './features/dynamic/dynamic-form-submission-detail.component';
import { DynamicFormsComponent } from './features/dynamic/dynamic-forms.component';
import { DynamicMigrationDetailComponent } from './features/dynamic/dynamic-migration-detail.component';
import { DynamicMigrationsComponent } from './features/dynamic/dynamic-migrations.component';
import { DynamicRecordsComponent } from './features/dynamic/dynamic-records.component';
import { FinanceAccountingReviewComponent } from './features/finance/finance-accounting-review.component';
import { FinanceAiRecommendationsComponent } from './features/finance/finance-ai-recommendations.component';
import { FinanceBankDetailComponent } from './features/finance/finance-bank-detail.component';
import { FinanceBanksComponent } from './features/finance/finance-banks.component';
import { FinanceBudgetsComponent } from './features/finance/finance-budgets.component';
import { FinanceCashboxDetailComponent } from './features/finance/finance-cashbox-detail.component';
import { FinanceCashboxesComponent } from './features/finance/finance-cashboxes.component';
import { FinanceConsolidationComponent } from './features/finance/finance-consolidation.component';
import { FinanceControlCenterAccountingBasisComponent } from './features/finance/finance-control-center-accounting-basis.component';
import { FinanceControlCenterBooksComponent } from './features/finance/finance-control-center-books.component';
import { FinanceControlCenterCapabilitiesComponent } from './features/finance/finance-control-center-capabilities.component';
import { FinanceControlCenterCurrenciesComponent } from './features/finance/finance-control-center-currencies.component';
import { FinanceControlCenterCurrencyDetailComponent } from './features/finance/finance-control-center-currency-detail.component';
import { FinanceControlCenterCurrencyPoliciesComponent } from './features/finance/finance-control-center-currency-policies.component';
import { FinanceControlCenterCurrencyPolicyDetailComponent } from './features/finance/finance-control-center-currency-policy-detail.component';
import { FinanceControlCenterFxRateDetailComponent } from './features/finance/finance-control-center-fx-rate-detail.component';
import { FinanceControlCenterFxRatesComponent } from './features/finance/finance-control-center-fx-rates.component';
import { FinanceControlCenterFundsComponent } from './features/finance/finance-control-center-funds.component';
import { FinanceControlCenterJournalPolicyComponent } from './features/finance/finance-control-center-journal-policy.component';
import { FinanceControlCenterPeriodsComponent } from './features/finance/finance-control-center-periods.component';
import { FinanceCustomerDetailComponent } from './features/finance/finance-customer-detail.component';
import { FinanceCustomersComponent } from './features/finance/finance-customers.component';
import { FinanceChartOfAccountsComponent } from './features/finance/finance-chart-of-accounts.component';
import { FinanceControlCenterComponent } from './features/finance/finance-control-center.component';
import { FinanceInvoicesComponent } from './features/finance/finance-invoices.component';
import { FinanceJournalEntryComponent } from './features/finance/finance-journal-entry.component';
import { FinancePaymentsDailyOverviewComponent } from './features/finance/finance-payments-daily-overview.component';
import { FinancePaymentsReportBankCashboxComponent } from './features/finance/finance-payments-report-bank-cashbox.component';
import { FinancePaymentsReportPayoutsComponent } from './features/finance/finance-payments-report-payouts.component';
import { FinancePaymentsReportReceiptsComponent } from './features/finance/finance-payments-report-receipts.component';
import { FinancePayoutDetailComponent } from './features/finance/finance-payout-detail.component';
import { FinancePayoutsComponent } from './features/finance/finance-payouts.component';
import { FinanceReceiptsComponent } from './features/finance/finance-receipts.component';
import { FinanceReceiptDetailComponent } from './features/finance/finance-receipt-detail.component';
import { FinanceReconciliationComponent } from './features/finance/finance-reconciliation.component';
import { FinanceSemanticMetricsComponent } from './features/finance/finance-semantic-metrics.component';
import { OrganizationFinanceOverviewComponent } from './features/finance/organization-finance-overview.component';
import { IdentityRolePermissionsComponent } from './features/identity/identity-role-permissions.component';
import { IdentityRolesComponent } from './features/identity/identity-roles.component';
import { IdentityUsersComponent } from './features/identity/identity-users.component';
import { UsersRolesComponent } from './features/identity/users-roles.component';
import { LoginComponent } from './features/login.component';
import { PublicFormPageComponent } from './features/public-forms/public-form-page.component';
import { PlatformTenantDetailComponent } from './features/platform/platform-tenant-detail.component';
import { PlatformTenantProvisionComponent } from './features/platform/platform-tenant-provision.component';
import { PlatformTenantsComponent } from './features/platform/platform-tenants.component';
import { PlatformLocalizationPreferencesComponent } from './features/platform/platform-localization-preferences.component';
import { PlatformLocalizationResourceManagerComponent } from './features/platform/platform-localization-resource-manager.component';
import { PlatformSystemOperationsComponent } from './features/platform/platform-system-operations.component';
import { PlatformRunningNumbersComponent } from './features/platform/platform-running-numbers.component';
import { PlatformGeographyAreasComponent } from './features/platform/platform-geography-areas.component';
import { PlatformGeographyAreaDetailComponent } from './features/platform/platform-geography-area-detail.component';
import { PlatformPartiesComponent } from './features/platform/platform-parties.component';
import { PlatformPartyDetailComponent } from './features/platform/platform-party-detail.component';
import { PlatformCustomerGroupsComponent } from './features/platform/platform-customer-groups.component';
import { PlatformComplianceQueueComponent } from './features/platform/platform-compliance-queue.component';
import { PlatformCustomerGroupDetailComponent } from './features/platform/platform-customer-group-detail.component';
import { PlatformPaymentTermsComponent } from './features/platform/platform-payment-terms.component';
import { PlatformPaymentTermDetailComponent } from './features/platform/platform-payment-term-detail.component';
import { PlatformUserPartyBindingsComponent } from './features/platform/platform-user-party-bindings.component';
import { PlatformUserPartyBindingDetailComponent } from './features/platform/platform-user-party-binding-detail.component';
import { PaymentsIntentsComponent } from './features/payments/payments-intents.component';
import { PaymentsLendingComponent } from './features/payments/payments-lending.component';
import { PaymentsBnplComponent } from './features/payments/payments-bnpl.component';
import { PaymentsPortfolioComponent } from './features/payments/payments-portfolio.component';
import { PaymentsFinancialCompletenessComponent } from './features/payments/payments-financial-completeness.component';
import { PaymentsProvidersComponent } from './features/payments/payments-providers.component';
import { PaymentsWalletComponent } from './features/payments/payments-wallet.component';
import { SubscriptionComponent } from './features/subscription/subscription.component';
import { SalesChannelDetailComponent } from './features/sales/sales-channel-detail.component';
import { SalesChannelsComponent } from './features/sales/sales-channels.component';
import { SalesDocumentProfileDetailComponent } from './features/sales/sales-document-profile-detail.component';
import { SalesDocumentProfilesComponent } from './features/sales/sales-document-profiles.component';
import { SalesPriceListDetailComponent } from './features/sales/sales-price-list-detail.component';
import { SalesPriceListsComponent } from './features/sales/sales-price-lists.component';
import { SalesCampaignsComponent } from './features/sales/sales-campaigns.component';
import { SalesCampaignDetailComponent } from './features/sales/sales-campaign-detail.component';
import { SalesCouponsComponent } from './features/sales/sales-coupons.component';
import { SalesCouponDetailComponent } from './features/sales/sales-coupon-detail.component';
import { SalesOrderDetailComponent } from './features/sales/sales-order-detail.component';
import { SalesOrdersComponent } from './features/sales/sales-orders.component';
import { SalesQuotasComponent } from './features/sales/sales-quotas.component';
import { SalesQuotaDetailComponent } from './features/sales/sales-quota-detail.component';
import { SalesReservationsComponent } from './features/sales/sales-reservations.component';
import { SalesReservationDetailComponent } from './features/sales/sales-reservation-detail.component';
import { SalesAllocationPoliciesComponent } from './features/sales/sales-allocation-policies.component';
import { SalesAllocationPolicyDetailComponent } from './features/sales/sales-allocation-policy-detail.component';
import { SalesCreditPoliciesComponent } from './features/sales/sales-credit-policies.component';
import { SalesCreditPolicyDetailComponent } from './features/sales/sales-credit-policy-detail.component';
import { SalesCustomerCreditLimitsComponent } from './features/sales/sales-customer-credit-limits.component';
import { SalesCustomerCreditLimitDetailComponent } from './features/sales/sales-customer-credit-limit-detail.component';
import { SalesCreditDecisionsComponent } from './features/sales/sales-credit-decisions.component';
import { SalesInstallmentPlansComponent } from './features/sales/sales-installment-plans.component';
import { SalesInstallmentPlanDetailComponent } from './features/sales/sales-installment-plan-detail.component';
import { SalesCommissionPlansComponent } from './features/sales/sales-commission-plans.component';
import { SalesCommissionPlanDetailComponent } from './features/sales/sales-commission-plan-detail.component';
import { SalesEnterpriseContractsComponent } from './features/sales/sales-enterprise-contracts.component';
import { SalesEnterpriseContractDetailComponent } from './features/sales/sales-enterprise-contract-detail.component';
import { SalesTendersComponent } from './features/sales/sales-tenders.component';
import { SalesTenderDetailComponent } from './features/sales/sales-tender-detail.component';
import { SalesAiRecommendationsComponent } from './features/sales/sales-ai-recommendations.component';
import { SalesAiRecommendationDetailComponent } from './features/sales/sales-ai-recommendation-detail.component';
import { SalesAiModelsComponent } from './features/sales/sales-ai-models.component';
import { SalesGoldQuotesComponent } from './features/sales/sales-gold-quotes.component';
import { SalesGoldQuoteDetailComponent } from './features/sales/sales-gold-quote-detail.component';
import { SalesGoldOrdersComponent } from './features/sales/sales-gold-orders.component';
import { SalesGoldOrderDetailComponent } from './features/sales/sales-gold-order-detail.component';
import { SalesBrokerageAccountsComponent } from './features/sales/sales-brokerage-accounts.component';
import { SalesBrokerageAccountDetailComponent } from './features/sales/sales-brokerage-account-detail.component';
import { SalesBrokerageOrdersComponent } from './features/sales/sales-brokerage-orders.component';
import { SalesBrokerageOrderDetailComponent } from './features/sales/sales-brokerage-order-detail.component';
import { SalesInsuranceQuotesComponent } from './features/sales/sales-insurance-quotes.component';
import { SalesInsuranceQuoteDetailComponent } from './features/sales/sales-insurance-quote-detail.component';
import { SalesInsurancePoliciesComponent } from './features/sales/sales-insurance-policies.component';
import { SalesInsurancePolicyDetailComponent } from './features/sales/sales-insurance-policy-detail.component';
import { SalesFxTradesComponent } from './features/sales/sales-fx-trades.component';
import { SalesFxTradeDetailComponent } from './features/sales/sales-fx-trade-detail.component';
import { SalesComplianceCasesComponent } from './features/sales/sales-compliance-cases.component';
import { SalesComplianceCaseDetailComponent } from './features/sales/sales-compliance-case-detail.component';
import { SalesConsignmentContractsComponent } from './features/sales/sales-consignment-contracts.component';
import { SalesConsignmentContractDetailComponent } from './features/sales/sales-consignment-contract-detail.component';
import { SalesCollectionCasesComponent } from './features/sales/sales-collection-cases.component';
import { SalesCollectionCaseDetailComponent } from './features/sales/sales-collection-case-detail.component';
import { SalesDistributionRoutesComponent } from './features/sales/sales-distribution-routes.component';
import { SalesDistributionRouteDetailComponent } from './features/sales/sales-distribution-route-detail.component';
import { SalesDistributionVisitDetailComponent } from './features/sales/sales-distribution-visit-detail.component';
import { SalesDistributionSettlementsComponent } from './features/sales/sales-distribution-settlements.component';
import { InsuranceClaimDetailComponent } from './features/insurance/insurance-claim-detail.component';
import { InsuranceClaimsShellComponent } from './features/insurance/insurance-claims-shell.component';
import { InsuranceCommissionAccrualsComponent } from './features/insurance/insurance-commission-accruals.component';
import { InsuranceCommissionPlanDetailComponent } from './features/insurance/insurance-commission-plan-detail.component';
import { InsuranceCommissionPlansComponent } from './features/insurance/insurance-commission-plans.component';
import { InsuranceCommissionSettlementDetailComponent } from './features/insurance/insurance-commission-settlement-detail.component';
import { InsuranceCommissionSettlementsComponent } from './features/insurance/insurance-commission-settlements.component';
import { InsuranceDistributionAdminComponent } from './features/insurance/insurance-distribution-admin.component';
import { InsuranceHealthProviderDetailComponent } from './features/insurance/insurance-health-provider-detail.component';
import { InsuranceHealthProvidersShellComponent } from './features/insurance/insurance-health-providers-shell.component';
import { InsuranceMasterPoliciesShellComponent } from './features/insurance/insurance-master-policies-shell.component';
import { InsuranceMasterPolicyDetailComponent } from './features/insurance/insurance-master-policy-detail.component';
import { InsurancePremiumInvoiceDetailComponent } from './features/insurance/insurance-premium-invoice-detail.component';
import { InsurancePremiumInvoicesComponent } from './features/insurance/insurance-premium-invoices.component';
import { InsurancePolicyDetailComponent } from './features/insurance/insurance-policy-detail.component';
import { InsurancePrintTemplatesManagementComponent } from './features/insurance/insurance-print-templates-management.component';
import { InsuranceProducerDetailComponent } from './features/insurance/insurance-producer-detail.component';
import { InsuranceProducersShellComponent } from './features/insurance/insurance-producers-shell.component';
import { InsuranceProposalDeskComponent } from './features/insurance/insurance-proposal-desk.component';
import { InsuranceProposalDetailComponent } from './features/insurance/insurance-proposal-detail.component';
import { InsuranceProductDetailComponent } from './features/insurance/insurance-product-detail.component';
import { InsuranceProductsShellComponent } from './features/insurance/insurance-products-shell.component';
import { InsuranceProductVersionsShellComponent } from './features/insurance/insurance-product-versions-shell.component';
import { InsuranceProductVersionDetailComponent } from './features/insurance/insurance-product-version-detail.component';
import { InsuranceQuoteDetailComponent } from './features/insurance/insurance-quote-detail.component';
import { InsuranceQuoteWorkbenchComponent } from './features/insurance/insurance-quote-workbench.component';
import { InsuranceRatingPlansComponent } from './features/insurance/insurance-rating-plans.component';
import { InsuranceRatingPlanDetailComponent } from './features/insurance/insurance-rating-plan-detail.component';
import { InsuranceReinsuranceTreatyDetailComponent } from './features/insurance/insurance-reinsurance-treaty-detail.component';
import { InsuranceReinsuranceTreatiesShellComponent } from './features/insurance/insurance-reinsurance-treaties-shell.component';
import { InsuranceRegulatoryJobsShellComponent } from './features/insurance/insurance-regulatory-jobs-shell.component';
import { InsuranceRegulatoryJobDetailComponent } from './features/insurance/insurance-regulatory-job-detail.component';
import { InsuranceAiRecommendationsComponent } from './features/insurance/insurance-ai-recommendations.component';
import { InsuranceAiRecommendationDetailComponent } from './features/insurance/insurance-ai-recommendation-detail.component';
import { InsuranceShellComponent } from './features/insurance/insurance-shell.component';
import { InsuranceUwCaseDetailComponent } from './features/insurance/insurance-uw-case-detail.component';
import { InsuranceUwInboxComponent } from './features/insurance/insurance-uw-inbox.component';
import { WorkflowDefinitionDetailComponent } from './features/workflow/workflow-definition-detail.component';
import { EventHubCatalogComponent } from './features/event-hub/event-hub-catalog.component';
import { EventHubCatalogDetailComponent } from './features/event-hub/event-hub-catalog-detail.component';
import { EventHubWebhookSubscriptionsComponent } from './features/event-hub/event-hub-webhook-subscriptions.component';
import { EventHubWebhookSubscriptionDetailComponent } from './features/event-hub/event-hub-webhook-subscription-detail.component';
import { EventHubObservabilityComponent } from './features/event-hub/event-hub-observability.component';
import { KnowledgeSourcesComponent } from './features/knowledge/knowledge-sources.component';
import { KnowledgeSourceDetailComponent } from './features/knowledge/knowledge-source-detail.component';
import { IoTDevicesComponent } from './features/iot/iot-devices.component';
import { IoTDeviceDetailComponent } from './features/iot/iot-device-detail.component';
import { WorkflowDefinitionsComponent } from './features/workflow/workflow-definitions.component';
import { WorkflowInstanceDetailComponent } from './features/workflow/workflow-instance-detail.component';
import { WorkflowTriggerSubscriptionsComponent } from './features/workflow/workflow-trigger-subscriptions.component';
import { WorkflowHookBindingsComponent } from './features/workflow/workflow-hook-bindings.component';
import { WorkflowIntentApprovalInboxComponent } from './features/workflow/workflow-intent-approval-inbox.component';
import { WorkflowIntentCreateComponent } from './features/workflow/workflow-intent-create.component';
import { WorkflowIntentDetailComponent } from './features/workflow/workflow-intent-detail.component';
import { WorkflowIntentEvaluationDashboardComponent } from './features/workflow/workflow-intent-evaluation-dashboard.component';
import { WorkflowIntentEvaluationRunDetailComponent } from './features/workflow/workflow-intent-evaluation-run-detail.component';
import { WorkflowIntentGovernanceComponent } from './features/workflow/workflow-intent-governance.component';
import { WorkflowIntentOpsListComponent } from './features/workflow/workflow-intent-ops-list.component';
import { WorkflowIntentSimulationRunComponent } from './features/workflow/workflow-intent-simulation-run.component';
import { WorkflowInstancesComponent } from './features/workflow/workflow-instances.component';
import { OrganizationAssignedFormsComponent } from './features/workflow/organization-assigned-forms.component';
import { OrganizationDynamicRecordsComponent } from './features/workflow/organization-dynamic-records.component';
import { OrganizationFormFillComponent } from './features/workflow/organization-form-fill.component';
import { WorkflowTaskDetailEntryComponent } from './features/workflow/workflow-task-detail-entry.component';
import { WorkflowTasksEntryComponent } from './features/workflow/workflow-tasks-entry.component';
import { GrowthAdminDashboardComponent } from './features/growth/growth-admin-dashboard.component';
import { GrowthIndustryPacksComponent } from './features/growth/growth-industry-packs.component';
import { GrowthIndustryPackDetailComponent } from './features/growth/growth-industry-pack-detail.component';
import { GrowthIndustryBindingsComponent } from './features/growth/growth-industry-bindings.component';
import { GrowthIndustryBindingDetailComponent } from './features/growth/growth-industry-binding-detail.component';
import { GrowthAgentMarketplaceListingsComponent } from './features/growth/growth-agent-marketplace-listings.component';
import { GrowthAgentMarketplaceListingDetailComponent } from './features/growth/growth-agent-marketplace-listing-detail.component';
import { GrowthAgentMarketplaceInstallsComponent } from './features/growth/growth-agent-marketplace-installs.component';
import { GrowthAgentMarketplaceInstallDetailComponent } from './features/growth/growth-agent-marketplace-install-detail.component';
import { GrowthIntegrationConnectorsComponent } from './features/growth/growth-integration-connectors.component';
import { GrowthIntegrationConnectorDetailComponent } from './features/growth/growth-integration-connector-detail.component';
import { GrowthIntegrationSyncStatusComponent } from './features/growth/growth-integration-sync-status.component';
import { GrowthPaidMediaAccountsComponent } from './features/growth/paid-media/growth-paid-media-accounts.component';
import { GrowthPaidMediaAccountDetailComponent } from './features/growth/paid-media/growth-paid-media-account-detail.component';
import { GrowthPaidMediaCampaignLinksComponent } from './features/growth/paid-media/growth-paid-media-campaign-links.component';
import { GrowthPaidMediaCampaignLinkDetailComponent } from './features/growth/paid-media/growth-paid-media-campaign-link-detail.component';
import { GrowthPaidMediaAudienceSyncComponent } from './features/growth/paid-media/growth-paid-media-audience-sync.component';
import { GrowthPaidMediaRoasComponent } from './features/growth/paid-media/growth-paid-media-roas.component';
import { GrowthTenantConfigComponent } from './features/growth/growth-tenant-config.component';
import { GrowthLeadsComponent } from './features/growth/growth-leads.component';
import { GrowthLeadDetailComponent } from './features/growth/growth-lead-detail.component';
import { GrowthSegmentsComponent } from './features/growth/growth-segments.component';
import { GrowthCustomer360Component } from './features/growth/growth-customer360.component';
import { GrowthConsentPreferenceCenterComponent } from './features/growth/growth-consent-preference-center.component';
import { GrowthCommsChannelsComponent } from './features/growth/growth-comms-channels.component';
import { GrowthMarketingCampaignsComponent } from './features/growth/growth-marketing-campaigns.component';
import { GrowthMarketingCampaignDetailComponent } from './features/growth/growth-marketing-campaign-detail.component';
import { GrowthContentAssetDetailComponent } from './features/growth/growth-content-asset-detail.component';
import { GrowthContentCalendarComponent } from './features/growth/growth-content-calendar.component';
import { GrowthContentReviewQueueComponent } from './features/growth/growth-content-review-queue.component';
import { GrowthSocialPostsComponent } from './features/growth/growth-social-posts.component';
import { GrowthAceContentStudioComponent } from './features/growth/growth-ace-content-studio.component';
import { GrowthAceBriefDetailComponent } from './features/growth/growth-ace-brief-detail.component';
import { GrowthArticlePublishingListComponent } from './features/growth/growth-article-publishing-list.component';
import { GrowthArticlePublishingDetailComponent } from './features/growth/growth-article-publishing-detail.component';
import { GrowthTgeConciergeComponent } from './features/growth/growth-tge-concierge.component';
import { GrowthSeoProfilesComponent } from './features/growth/growth-seo-profiles.component';
import { GrowthSearchOpsWorkHomeComponent } from './features/growth/search-ops/growth-search-ops-work-home.component';
import { GrowthSearchOpsPropertiesComponent } from './features/growth/search-ops/growth-search-ops-properties.component';
import { GrowthSearchOpsPropertyDetailComponent } from './features/growth/search-ops/growth-search-ops-property-detail.component';
import { GrowthSearchOpsBacklogComponent } from './features/growth/search-ops/growth-search-ops-backlog.component';
import { GrowthSearchOpsCoworkersComponent } from './features/growth/search-ops/growth-search-ops-coworkers.component';
import { GrowthSearchOpsKeywordsComponent } from './features/growth/search-ops/growth-search-ops-keywords.component';
import { GrowthSearchOpsUrlsComponent } from './features/growth/search-ops/growth-search-ops-urls.component';
import { GrowthSearchOpsIssuesComponent } from './features/growth/search-ops/growth-search-ops-issues.component';
import { GrowthSearchOpsRedirectsComponent } from './features/growth/search-ops/growth-search-ops-redirects.component';
import { GrowthSearchOpsApplyQueueComponent } from './features/growth/search-ops/growth-search-ops-apply-queue.component';
import { GrowthSearchOpsOffpageComponent } from './features/growth/search-ops/growth-search-ops-offpage.component';
import { GrowthSearchOpsLocalComponent } from './features/growth/search-ops/growth-search-ops-local.component';
import { GrowthSearchOpsSemComponent } from './features/growth/search-ops/growth-search-ops-sem.component';
import { GrowthSearchOpsScorecardComponent } from './features/growth/search-ops/growth-search-ops-scorecard.component';
import { GrowthSearchOpsReportsComponent } from './features/growth/search-ops/growth-search-ops-reports.component';
import { GrowthAeoAnswersComponent } from './features/growth/growth-aeo-answers.component';
import { GrowthSxoExperimentsComponent } from './features/growth/growth-sxo-experiments.component';
import { GrowthGeoProfilesComponent } from './features/growth/growth-geo-profiles.component';
import { GrowthIntelligenceDashboardComponent } from './features/growth/growth-intelligence-dashboard.component';
import { GrowthAttributionComponent } from './features/growth/growth-attribution.component';
import { GrowthFunnelsComponent } from './features/growth/growth-funnels.component';
import { GrowthCohortsComponent } from './features/growth/growth-cohorts.component';
import { GrowthScoresComponent } from './features/growth/growth-scores.component';
import { GrowthForecastComponent } from './features/growth/growth-forecast.component';
import { GrowthContentPerformanceComponent } from './features/growth/growth-content-performance.component';
import { GrowthAgentConsoleComponent } from './features/growth/growth-agent-console.component';
import { GrowthOptimizerConsoleComponent } from './features/growth/growth-optimizer-console.component';
import { GrowthOptimizerRunsComponent } from './features/growth/growth-optimizer-runs.component';
import { GrowthOptimizerGuardrailsComponent } from './features/growth/growth-optimizer-guardrails.component';
import { GrowthOptimizerAutomationComponent } from './features/growth/growth-optimizer-automation.component';
import { GrowthOptimizerRunDetailComponent } from './features/growth/growth-optimizer-run-detail.component';
import { GrowthBusinessTwinComponent } from './features/growth/growth-business-twin.component';
import { GrowthTwinScenariosComponent } from './features/growth/growth-twin-scenarios.component';
import { GrowthTwinScenarioDetailComponent } from './features/growth/growth-twin-scenario-detail.component';
import { GrowthSuccessPlansComponent } from './features/growth/growth-success-plans.component';
import { GrowthSuccessPlanDetailComponent } from './features/growth/growth-success-plan-detail.component';
import { GrowthRetentionPlaysComponent } from './features/growth/growth-retention-plays.component';
import { GrowthRetentionPlayDetailComponent } from './features/growth/growth-retention-play-detail.component';
import {
  GrowthAgentRecommendationsComponent,
  GrowthAgentRecommendationDetailComponent,
  GrowthAgentApprovalQueueComponent,
  GrowthAgentRunDetailComponent
} from './features/growth/growth-agent-recommendations.component';
import { GrowthAgentGuardrailsComponent } from './features/growth/growth-agent-guardrails.component';
import { GrowthAgentWorkflowBindingsComponent } from './features/growth/growth-agent-workflow-bindings.component';
import { GrowthStrategyArtifactsComponent } from './features/growth/growth-strategy-artifacts.component';
import { GrowthStrategyArtifactDetailComponent } from './features/growth/growth-strategy-artifact-detail.component';
import { GrowthStrategyActivationPlansComponent } from './features/growth/growth-strategy-activation-plans.component';
import { GrowthStrategyActivationPlanDetailComponent } from './features/growth/growth-strategy-activation-plan-detail.component';
import { GrowthBusinessDiscoveryListComponent } from './features/growth/growth-business-discovery-list.component';
import { GrowthBusinessDiscoveryDetailComponent } from './features/growth/growth-business-discovery-detail.component';
import { GrowthJourneyListComponent } from './features/growth/growth-journey-list.component';
import { GrowthJourneyDashboardComponent } from './features/growth/growth-journey-dashboard.component';
import { GrowthBrandVoiceListComponent } from './features/growth/growth-brand-voice-list.component';
import { GrowthBrandVoiceDetailComponent } from './features/growth/growth-brand-voice-detail.component';
import { GrowthSwotFactorCatalogComponent } from './features/growth/growth-swot-factor-catalog.component';
import { GrowthPublishOperationsComponent } from './features/growth/growth-publish-operations.component';
import { GrowthCommsDistributionComponent } from './features/growth/growth-comms-distribution.component';
import { GrowthCommsDistributionDetailComponent } from './features/growth/growth-comms-distribution-detail.component';
import { NotificationsMessagesComponent } from './features/notifications/notifications-messages.component';
import { NotificationsMessageDetailComponent } from './features/notifications/notifications-message-detail.component';
import { NotificationsProvidersComponent } from './features/notifications/notifications-providers.component';
import { NotificationsTemplatesComponent } from './features/notifications/notifications-templates.component';
import { NotificationsTemplateDetailComponent } from './features/notifications/notifications-template-detail.component';
import { NotificationsDeliveryComponent } from './features/notifications/notifications-delivery.component';
import { NotificationsPolicyComponent } from './features/notifications/notifications-policy.component';
import { PlannedModulePlaceholderComponent } from './features/planned/planned-module-placeholder.component';
import { buildPlaceholderRoutes } from './core/navigation/navigation-placeholder-routes';
import { PLACEHOLDER_SCREEN_DEFS } from './core/navigation/navigation-placeholder-manifest';
import { COMMS_REDIRECT_ROUTES, COMMS_ROUTES } from './features/comms/comms.routes';
import { GRC_ROUTES } from './features/grc/grc.routes';
import { FCC_ROUTES } from './features/fcc/fcc.routes';
import { ShellComponent } from './layout/shell.component';
import { environment } from '../environments/environment';

const identityUsersRouteComponent = environment.features.adminUxV2 ? IdentityUsersComponent : UsersRolesComponent;
const identityRolesRouteComponent = environment.features.adminUxV2 ? IdentityRolesComponent : UsersRolesComponent;
const identityRolePermissionsRouteComponent = environment.features.adminUxV2 ? IdentityRolePermissionsComponent : UsersRolesComponent;

export const routes: Routes = [
  { path: 'public/forms/resume/:token', component: PublicFormPageComponent },
  { path: 'public/forms/:slug', component: PublicFormPageComponent },
  { path: 'login', component: LoginComponent },
  {
    path: '',
    component: ShellComponent,
    canActivate: [authGuard],
    canActivateChild: [scopeGuard, wizardGateGuard],
    children: [
      { path: '', pathMatch: 'full', redirectTo: 'dashboard' },
      {
        path: 'wizards/runs/:runId',
        component: WizardRunHostComponent,
        canActivate: [permissionGuard],
        data: {
          requiredScopes: ['admin', 'organization']
        }
      },
      { path: 'dashboard', component: DashboardComponent, data: { requiredScopes: ['admin', 'organization'] } },
      {
        path: 'platform/tenants',
        component: PlatformTenantsComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'platform-core', requiredScopes: ['admin'] }
      },
      {
        path: 'platform/tenants/provision',
        component: PlatformTenantProvisionComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'platform-core', requiredScopes: ['admin'] }
      },
      {
        path: 'platform/tenants/:id',
        component: PlatformTenantDetailComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'platform-core', requiredScopes: ['admin'] }
      },
      {
        path: 'platform/localization-preferences',
        component: PlatformLocalizationPreferencesComponent,
        data: { requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'platform/localization-resources',
        component: PlatformLocalizationResourceManagerComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'platform-core', requiredAction: 'Update', requiredScopes: ['admin'] }
      },
      {
        path: 'platform/system-operations',
        component: PlatformSystemOperationsComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'platform-core', requiredAction: 'ManageSettings', requiredScopes: ['admin'] }
      },
      {
        path: 'platform/running-numbers',
        component: PlatformRunningNumbersComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'platform-core', requiredScopes: ['admin'] }
      },
      {
        path: 'platform/geography',
        component: PlatformGeographyAreasComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'platform-core', requiredScopes: ['admin'] }
      },
      {
        path: 'platform/geography/:areaId',
        component: PlatformGeographyAreaDetailComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'platform-core', requiredScopes: ['admin'] }
      },
      {
        path: 'platform/customers',
        pathMatch: 'full',
        redirectTo: 'financial/payments/customers'
      },
      {
        path: 'platform/parties',
        component: PlatformPartiesComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'platform-core', requiredScopes: ['admin'] }
      },
      {
        path: 'platform/parties/kinds/:kindKey',
        component: PlatformPartiesComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'platform-core', requiredScopes: ['admin'] }
      },
      {
        path: 'platform/parties/:partyId',
        component: PlatformPartyDetailComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'platform-core', requiredScopes: ['admin'] }
      },
      {
        path: 'platform/customer-groups',
        component: PlatformCustomerGroupsComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'platform-core', requiredScopes: ['admin'] }
      },
      {
        path: 'platform/customer-groups/:groupId',
        component: PlatformCustomerGroupDetailComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'platform-core', requiredScopes: ['admin'] }
      },
      {
        path: 'platform/payment-terms',
        component: PlatformPaymentTermsComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'platform-core', requiredScopes: ['admin'] }
      },
      {
        path: 'platform/payment-terms/:paymentTermId',
        component: PlatformPaymentTermDetailComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'platform-core', requiredScopes: ['admin'] }
      },
      {
        path: 'platform/compliance-queue/pending-kyc-kyb',
        component: PlatformComplianceQueueComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'platform-core', requiredScopes: ['admin'] }
      },
      {
        path: 'platform/user-party-bindings',
        component: PlatformUserPartyBindingsComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'platform.tenants.manage', requiredScopes: ['admin'] }
      },
      {
        path: 'platform/user-party-bindings/:bindingId',
        component: PlatformUserPartyBindingDetailComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'platform.tenants.manage', requiredScopes: ['admin'] }
      },
      {
        path: 'payments/providers',
        component: PaymentsProvidersComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'payments.providers', requiredScopes: ['admin'] }
      },
      {
        path: 'payments/intents',
        component: PaymentsIntentsComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'payments.intents', requiredScopes: ['admin'] }
      },
      {
        path: 'payments/wallet',
        component: PaymentsWalletComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'payments.wallet', requiredScopes: ['admin'] }
      },
      {
        path: 'payments/lending',
        component: PaymentsLendingComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'payments.lending', requiredScopes: ['admin'] }
      },
      {
        path: 'payments/bnpl',
        component: PaymentsBnplComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'payments.lending', requiredScopes: ['admin'] }
      },
      {
        path: 'payments/portfolio',
        component: PaymentsPortfolioComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'payments.portfolio', requiredScopes: ['admin'] }
      },
      {
        path: 'payments/financial-completeness',
        component: PaymentsFinancialCompletenessComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'payments.portfolio', requiredScopes: ['admin'] }
      },
      {
        path: 'identity/users',
        component: identityUsersRouteComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'identity-access', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'identity/roles',
        component: identityRolesRouteComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'identity-access', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'identity/roles/:roleId/permissions',
        component: identityRolePermissionsRouteComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'identity-access', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'subscription/current',
        component: SubscriptionComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'subscription-billing', requiredScopes: ['admin'] }
      },
      {
        path: 'catalog',
        component: CatalogComponent,
        canActivate: [permissionGuard],
        data: { requiredEntitlement: 'catalog', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'catalog/products',
        component: CatalogProductsHubComponent,
        canActivate: [permissionGuard],
        data: { requiredEntitlement: 'catalog', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'catalog/offerings',
        redirectTo: 'catalog/products?tab=offerings',
        pathMatch: 'full'
      },
      {
        path: 'catalog/categories',
        redirectTo: 'catalog/products?tab=categories',
        pathMatch: 'full'
      },
      {
        path: 'catalog/attributes',
        redirectTo: 'catalog/products?tab=attributes',
        pathMatch: 'full'
      },
      {
        path: 'catalog/media',
        redirectTo: 'catalog/products?tab=media',
        pathMatch: 'full'
      },
      {
        path: 'catalog/offering-profiles',
        redirectTo: 'catalog/products?tab=offerings&hubHint=profiles',
        pathMatch: 'full'
      },
      {
        path: 'catalog/offerings/:id',
        component: CatalogOfferingDetailComponent,
        canActivate: [permissionGuard],
        data: { requiredEntitlement: 'catalog', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'sales/document-profiles',
        component: SalesDocumentProfilesComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'sales.document-profiles.view', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'sales/document-profiles/:profileId',
        component: SalesDocumentProfileDetailComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'sales.document-profiles.view', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'sales/price-lists',
        component: SalesPriceListsComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'sales.price-lists.view', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'sales/price-lists/:priceListId',
        component: SalesPriceListDetailComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'sales.price-lists.view', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'sales/campaigns',
        component: SalesCampaignsComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'sales.promotions.view', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'sales/campaigns/:campaignId',
        component: SalesCampaignDetailComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'sales.promotions.view', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'sales/coupons',
        component: SalesCouponsComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'sales.promotions.view', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'sales/coupons/:couponId',
        component: SalesCouponDetailComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'sales.promotions.view', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'sales/channels',
        component: SalesChannelsComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'sales.channels.view', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'sales/channels/:channelId',
        component: SalesChannelDetailComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'sales.channels.view', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'sales/quotas',
        component: SalesQuotasComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'sales.quotas.view', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'sales/quotas/:quotaId',
        component: SalesQuotaDetailComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'sales.quotas.view', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'sales/reservations',
        component: SalesReservationsComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'sales.reservations.view', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'sales/reservations/:reservationId',
        component: SalesReservationDetailComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'sales.reservations.view', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'sales/allocation-policies',
        component: SalesAllocationPoliciesComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'sales.allocations.view', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'sales/allocation-policies/:policyId',
        component: SalesAllocationPolicyDetailComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'sales.allocations.view', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'sales/credit-policies',
        component: SalesCreditPoliciesComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'sales.credit.view', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'sales/credit-policies/:policyId',
        component: SalesCreditPolicyDetailComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'sales.credit.view', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'sales/customer-credit-limits',
        component: SalesCustomerCreditLimitsComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'sales.credit.view', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'sales/customer-credit-limits/:limitId',
        component: SalesCustomerCreditLimitDetailComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'sales.credit.view', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'sales/credit-decisions',
        component: SalesCreditDecisionsComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'sales.credit.view', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'sales/installment-plans',
        component: SalesInstallmentPlansComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'sales.installments.view', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'sales/installment-plans/:planId',
        component: SalesInstallmentPlanDetailComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'sales.installments.view', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'sales/commission-plans',
        component: SalesCommissionPlansComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'sales.commissions.view', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'sales/commission-plans/:planId',
        component: SalesCommissionPlanDetailComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'sales.commissions.view', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'sales/quotes',
        component: SalesOrdersComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'sales.orders.view', requiredScopes: ['admin', 'organization'], documentContext: 'proforma' }
      },
      {
        path: 'sales/quotes/:orderId',
        component: SalesOrderDetailComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'sales.orders.view', requiredScopes: ['admin', 'organization'], documentContext: 'proforma' }
      },
      {
        path: 'sales/contracts',
        component: SalesEnterpriseContractsComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'sales.contracts.view', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'sales/contracts/:contractId',
        component: SalesEnterpriseContractDetailComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'sales.contracts.view', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'sales/tenders',
        component: SalesTendersComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'sales.tenders.view', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'sales/tenders/:tenderId',
        component: SalesTenderDetailComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'sales.tenders.view', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'sales/ai-recommendations',
        component: SalesAiRecommendationsComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'sales.ai.view', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'sales/ai-recommendations/:recommendationId',
        component: SalesAiRecommendationDetailComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'sales.ai.view', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'sales/ai-models',
        component: SalesAiModelsComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'sales.ai.view', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'sales/gold-quotes',
        component: SalesGoldQuotesComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'sales.regulated.view', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'sales/gold-quotes/:quoteId',
        component: SalesGoldQuoteDetailComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'sales.regulated.view', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'sales/gold-orders',
        component: SalesGoldOrdersComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'sales.regulated.view', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'sales/gold-orders/:orderId',
        component: SalesGoldOrderDetailComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'sales.regulated.view', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'sales/brokerage-accounts',
        component: SalesBrokerageAccountsComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'sales.regulated.view', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'sales/brokerage-accounts/:accountId',
        component: SalesBrokerageAccountDetailComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'sales.regulated.view', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'sales/brokerage-orders',
        component: SalesBrokerageOrdersComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'sales.regulated.view', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'sales/brokerage-orders/:orderId',
        component: SalesBrokerageOrderDetailComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'sales.regulated.view', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'sales/insurance-quotes',
        component: SalesInsuranceQuotesComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'sales.regulated.view', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'sales/insurance-quotes/:quoteId',
        component: SalesInsuranceQuoteDetailComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'sales.regulated.view', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'sales/insurance-policies',
        component: SalesInsurancePoliciesComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'sales.regulated.view', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'sales/insurance-policies/:policyId',
        component: SalesInsurancePolicyDetailComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'sales.regulated.view', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'sales/fx-trades',
        component: SalesFxTradesComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'sales.regulated.view', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'sales/fx-trades/new-quote',
        component: SalesFxTradeDetailComponent,
        canActivate: [permissionGuard],
        data: { mode: 'quote', requiredPermission: 'sales.regulated.create', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'sales/fx-trades/:tradeId',
        component: SalesFxTradeDetailComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'sales.regulated.view', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'sales/compliance-cases',
        component: SalesComplianceCasesComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'sales.regulated.view', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'sales/compliance-cases/suitability',
        component: SalesComplianceCaseDetailComponent,
        canActivate: [permissionGuard],
        data: { mode: 'suitability', requiredPermission: 'sales.regulated.create', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'sales/compliance-cases/:caseId',
        component: SalesComplianceCaseDetailComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'sales.regulated.view', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'sales/consignment-contracts',
        component: SalesConsignmentContractsComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'sales.consignments.view', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'sales/consignment-contracts/:contractId',
        component: SalesConsignmentContractDetailComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'sales.consignments.view', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'sales/collection-cases',
        component: SalesCollectionCasesComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'sales.collections.view', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'sales/collection-cases/:caseId',
        component: SalesCollectionCaseDetailComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'sales.collections.view', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'sales/distribution-routes',
        component: SalesDistributionRoutesComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'sales.distribution.view', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'sales/distribution-routes/:routeId',
        component: SalesDistributionRouteDetailComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'sales.distribution.view', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'sales/distribution-visits/:visitId',
        component: SalesDistributionVisitDetailComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'sales.distribution.view', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'sales/distribution-settlements',
        component: SalesDistributionSettlementsComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'sales.distribution.view', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'sales/orders',
        component: SalesOrdersComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'sales.orders.view', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'sales/orders/:orderId',
        component: SalesOrderDetailComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'sales.orders.view', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'inventory/warehouses',
        component: InventoryWarehousesComponent,
        canActivate: [permissionGuard],
        data: { requiredEntitlement: 'catalog', requiredPermission: 'inventory.warehouses.view', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'inventory/warehouses/:id',
        component: InventoryWarehouseDetailV2Component,
        canActivate: [permissionGuard],
        data: { requiredEntitlement: 'catalog', requiredPermission: 'inventory.warehouses.view', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'inventory/movements',
        component: InventoryMovementsComponent,
        canActivate: [permissionGuard],
        data: { requiredEntitlement: 'catalog', requiredPermission: 'inventory.stock.view', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'inventory/movements/:id',
        component: InventoryMovementDetailComponent,
        canActivate: [permissionGuard],
        data: { requiredEntitlement: 'catalog', requiredPermission: 'inventory.stock.view', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'inventory/count-sessions',
        component: InventoryCountSessionsComponent,
        canActivate: [permissionGuard],
        data: { requiredEntitlement: 'catalog', requiredPermission: 'inventory.stock.view', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'inventory/inbound-shipments',
        component: InventoryInboundShipmentsComponent,
        canActivate: [permissionGuard],
        data: { requiredEntitlement: 'catalog', requiredPermission: 'inventory.inbound.view', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'inventory/inbound-shipments/:id',
        component: InventoryInboundShipmentDetailComponent,
        canActivate: [permissionGuard],
        data: { requiredEntitlement: 'catalog', requiredPermission: 'inventory.inbound.view', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'inventory/requisitions',
        component: InventoryRequisitionsComponent,
        canActivate: [permissionGuard],
        data: { requiredEntitlement: 'catalog', requiredPermission: 'inventory.requisitions.view', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'inventory/requisitions/:id',
        component: InventoryRequisitionDetailComponent,
        canActivate: [permissionGuard],
        data: { requiredEntitlement: 'catalog', requiredPermission: 'inventory.requisitions.view', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'inventory/supply-orders/:id',
        component: InventorySupplyOrderDetailComponent,
        canActivate: [permissionGuard],
        data: { requiredEntitlement: 'catalog', requiredPermission: 'inventory.requisitions.view', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'inventory/replenishment-policies',
        component: InventoryReplenishmentPoliciesComponent,
        canActivate: [permissionGuard],
        data: { requiredEntitlement: 'catalog', requiredPermission: 'inventory.replenishment.view', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'inventory/replenishment-policies/:id',
        component: InventoryReplenishmentPolicyDetailComponent,
        canActivate: [permissionGuard],
        data: { requiredEntitlement: 'catalog', requiredPermission: 'inventory.replenishment.view', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'inventory/replenishment-breaches',
        component: InventoryReplenishmentBreachesComponent,
        canActivate: [permissionGuard],
        data: { requiredEntitlement: 'catalog', requiredPermission: 'inventory.replenishment.view', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'inventory/expiry-status',
        component: InventoryExpiryStatusComponent,
        canActivate: [permissionGuard],
        data: { requiredEntitlement: 'catalog', requiredPermission: 'inventory.stock.view', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'inventory/reports',
        component: InventoryOfficialReportsHubComponent,
        canActivate: [permissionGuard],
        data: { requiredEntitlement: 'catalog', requiredPermission: 'inventory.reports.view', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'inventory/reservations',
        component: InventoryReservationsComponent,
        canActivate: [permissionGuard],
        data: { requiredEntitlement: 'catalog', requiredPermission: 'inventory.reservations.view', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'inventory/pick-waves',
        component: InventoryPickWavesComponent,
        canActivate: [permissionGuard],
        data: { requiredEntitlement: 'catalog', requiredPermission: 'inventory.reservations.view', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'inventory/pick-waves/:id',
        component: InventoryPickWaveDetailComponent,
        canActivate: [permissionGuard],
        data: { requiredEntitlement: 'catalog', requiredPermission: 'inventory.reservations.view', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'inventory/warehouse-tasks',
        component: InventoryWarehouseTasksComponent,
        canActivate: [permissionGuard],
        data: { requiredEntitlement: 'catalog', requiredPermission: 'inventory.tasks.view', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'inventory/outbound-shipments',
        component: InventoryOutboundShipmentsComponent,
        canActivate: [permissionGuard],
        data: { requiredEntitlement: 'catalog', requiredPermission: 'inventory.tasks.view', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'inventory/carrier-webhook-events',
        component: InventoryCarrierWebhookEventsComponent,
        canActivate: [permissionGuard],
        data: { requiredEntitlement: 'catalog', requiredPermission: 'inventory.tasks.view', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'inventory/operator',
        component: InventoryOperatorComponent,
        canActivate: [permissionGuard],
        data: { requiredEntitlement: 'catalog', requiredPermission: 'inventory.tasks.view', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'inventory/kpi-dashboard',
        component: InventoryKpiDashboardComponent,
        canActivate: [permissionGuard],
        data: { requiredEntitlement: 'catalog', requiredPermission: 'inventory.stock.view', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'inventory/internal-consumption',
        component: InventoryInternalConsumptionComponent,
        canActivate: [permissionGuard],
        data: { requiredEntitlement: 'catalog', requiredPermission: 'inventory.stock.view', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'inventory/lots',
        component: InventoryLotsComponent,
        canActivate: [permissionGuard],
        data: { requiredEntitlement: 'catalog', requiredPermission: 'inventory.tracking.view', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'inventory/lots/:id',
        component: InventoryLotDetailComponent,
        canActivate: [permissionGuard],
        data: { requiredEntitlement: 'catalog', requiredPermission: 'inventory.tracking.view', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'inventory/serials',
        component: InventorySerialsComponent,
        canActivate: [permissionGuard],
        data: { requiredEntitlement: 'catalog', requiredPermission: 'inventory.tracking.view', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'inventory/serials/:id',
        component: InventorySerialDetailComponent,
        canActivate: [permissionGuard],
        data: { requiredEntitlement: 'catalog', requiredPermission: 'inventory.tracking.view', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'inventory/qc-inspections',
        component: InventoryQcInspectionsComponent,
        canActivate: [permissionGuard],
        data: { requiredEntitlement: 'catalog', requiredPermission: 'inventory.qc.view', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'inventory/qc-inspections/:id',
        component: InventoryQcInspectionDetailComponent,
        canActivate: [permissionGuard],
        data: { requiredEntitlement: 'catalog', requiredPermission: 'inventory.qc.view', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'inventory/traceability',
        component: InventoryTraceabilityComponent,
        canActivate: [permissionGuard],
        data: { requiredEntitlement: 'catalog', requiredPermission: 'inventory.tracking.view', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'inventory/recalls',
        component: InventoryRecallsComponent,
        canActivate: [permissionGuard],
        data: { requiredEntitlement: 'catalog', requiredPermission: 'inventory.recall.view', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'inventory/recalls/:id',
        component: InventoryRecallDetailComponent,
        canActivate: [permissionGuard],
        data: { requiredEntitlement: 'catalog', requiredPermission: 'inventory.recall.view', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'inventory/costing/policies',
        component: InventoryCostingPoliciesComponent,
        canActivate: [permissionGuard],
        data: { requiredEntitlement: 'catalog', requiredPermission: 'inventory.costing.view', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'inventory/costing/policies/:id',
        component: InventoryCostingPolicyDetailComponent,
        canActivate: [permissionGuard],
        data: { requiredEntitlement: 'catalog', requiredPermission: 'inventory.costing.view', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'inventory/costing/valuation',
        component: InventoryValuationComponent,
        canActivate: [permissionGuard],
        data: { requiredEntitlement: 'catalog', requiredPermission: 'inventory.costing.view', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'inventory/costing/valuation/snapshots/:id',
        component: InventoryValuationSnapshotComponent,
        canActivate: [permissionGuard],
        data: { requiredEntitlement: 'catalog', requiredPermission: 'inventory.costing.view', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'inventory/costing/layers',
        component: InventoryCostLayersComponent,
        canActivate: [permissionGuard],
        data: { requiredEntitlement: 'catalog', requiredPermission: 'inventory.costing.view', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'inventory/costing/layers/:id',
        component: InventoryCostLayerDetailComponent,
        canActivate: [permissionGuard],
        data: { requiredEntitlement: 'catalog', requiredPermission: 'inventory.costing.view', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'inventory/costing/revaluations',
        component: InventoryRevaluationsComponent,
        canActivate: [permissionGuard],
        data: { requiredEntitlement: 'catalog', requiredPermission: 'inventory.costing.view', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'inventory/costing/revaluations/:id',
        component: InventoryRevaluationDetailComponent,
        canActivate: [permissionGuard],
        data: { requiredEntitlement: 'catalog', requiredPermission: 'inventory.costing.view', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'inventory/costing/operability',
        component: InventoryOperabilityComponent,
        canActivate: [permissionGuard],
        data: { requiredEntitlement: 'catalog', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'services/orders',
        component: ServiceOrdersComponent,
        canActivate: [permissionGuard],
        data: { requiredEntitlement: 'catalog', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'services/orders/:id',
        component: ServiceOrderDetailComponent,
        canActivate: [permissionGuard],
        data: { requiredEntitlement: 'catalog', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'services/resources',
        component: ServiceResourcesComponent,
        canActivate: [permissionGuard],
        data: { requiredEntitlement: 'catalog', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'services/rma',
        component: RmaRequestsComponent,
        canActivate: [permissionGuard],
        data: { requiredEntitlement: 'catalog', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'services/rma/:id',
        component: RmaRequestDetailComponent,
        canActivate: [permissionGuard],
        data: { requiredEntitlement: 'catalog', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'operations/control-room',
        component: OperationsControlRoomComponent,
        canActivate: [permissionGuard],
        data: { requiredEntitlement: 'catalog', requiredPermission: 'operations.control-room.view', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'inventory/tracking-dashboard',
        component: InventoryTrackingDashboardComponent,
        canActivate: [permissionGuard],
        data: { requiredEntitlement: 'catalog', requiredPermission: 'inventory.tracking.view', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'services/dispatch-board',
        component: ServiceDispatchBoardComponent,
        canActivate: [permissionGuard],
        data: { requiredEntitlement: 'catalog', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'services/technician',
        component: TechnicianWorkQueueComponent,
        canActivate: [permissionGuard],
        data: { requiredEntitlement: 'catalog', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'assets/register',
        component: AssetRegisterComponent,
        canActivate: [permissionGuard],
        data: { requiredEntitlement: 'catalog', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'assets/register/:id',
        component: AssetDetailComponent,
        canActivate: [permissionGuard],
        data: { requiredEntitlement: 'catalog', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'rental/agreements',
        component: RentalAgreementsComponent,
        canActivate: [permissionGuard],
        data: { requiredEntitlement: 'catalog', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'rental/agreements/:id',
        component: RentalAgreementDetailComponent,
        canActivate: [permissionGuard],
        data: { requiredEntitlement: 'catalog', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'rental/booking-board',
        component: RentalBookingBoardComponent,
        canActivate: [permissionGuard],
        data: { requiredEntitlement: 'catalog', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'hospitality/properties',
        component: HospitalityPropertiesComponent,
        canActivate: [permissionGuard],
        data: { requiredEntitlement: 'catalog', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'hospitality/properties/:id',
        component: HospitalityPropertyDetailComponent,
        canActivate: [permissionGuard],
        data: { requiredEntitlement: 'catalog', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'hospitality/reservations',
        component: HospitalityReservationsComponent,
        canActivate: [permissionGuard],
        data: { requiredEntitlement: 'catalog', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'hospitality/reservations/:id',
        component: HospitalityReservationDetailComponent,
        canActivate: [permissionGuard],
        data: { requiredEntitlement: 'catalog', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'hospitality/housekeeping',
        component: HospitalityHousekeepingComponent,
        canActivate: [permissionGuard],
        data: { requiredEntitlement: 'catalog', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'hospitality/rate-calendar',
        component: HospitalityRateCalendarComponent,
        canActivate: [permissionGuard],
        data: { requiredEntitlement: 'catalog', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'hospitality/front-desk',
        component: HospitalityFrontDeskComponent,
        canActivate: [permissionGuard],
        data: { requiredEntitlement: 'catalog', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'hospitality/kpi-dashboard',
        component: HospitalityKpiDashboardComponent,
        canActivate: [permissionGuard],
        data: { requiredEntitlement: 'catalog', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'hospitality/booking-board',
        component: HospitalityBookingBoardComponent,
        canActivate: [permissionGuard],
        data: { requiredEntitlement: 'catalog', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'hospitality/policy-exceptions',
        component: HospitalityPolicyExceptionsComponent,
        canActivate: [permissionGuard],
        data: { requiredEntitlement: 'catalog', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'hospitality/room-maintenance',
        component: HospitalityRoomMaintenanceComponent,
        canActivate: [permissionGuard],
        data: { requiredEntitlement: 'catalog', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'commerce/orders',
        component: UnifiedCommerceOrdersComponent,
        canActivate: [permissionGuard],
        data: { requiredEntitlement: 'catalog', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'regulated-finance/cockpit',
        component: RegulatedFinanceCockpitComponent,
        canActivate: [permissionGuard],
        data: { requiredEntitlement: 'catalog', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'digital/entitlements/:id',
        component: DigitalEntitlementDetailComponent,
        canActivate: [permissionGuard],
        data: { requiredEntitlement: 'catalog', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'digital/entitlements',
        component: DigitalEntitlementsComponent,
        canActivate: [permissionGuard],
        data: { requiredEntitlement: 'catalog', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'subscription/contracts',
        component: SubscriptionContractsComponent,
        canActivate: [permissionGuard],
        data: { requiredEntitlement: 'catalog', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'subscription/contracts/:id',
        component: SubscriptionContractDetailComponent,
        canActivate: [permissionGuard],
        data: { requiredEntitlement: 'catalog', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'commercial/modules',
        component: CommercialModulesComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'commercial.modules.manage', requiredScopes: ['admin'] }
      },
      {
        path: 'commercial/plans',
        component: CommercialPlansComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'commercial.plans.manage', requiredScopes: ['admin'] }
      },
      {
        path: 'commercial/add-ons',
        component: CommercialAddonsComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'commercial.modules.manage', requiredScopes: ['admin'] }
      },
      {
        path: 'marketplace/industry-solutions',
        component: MarketplaceIndustrySolutionsComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'marketplace.storefront.manage', requiredEntitlement: 'catalog', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'marketplace/dashboard',
        component: MarketplaceDashboardComponent,
        canActivate: [permissionGuard],
        data: { requiredEntitlement: 'catalog', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'marketplace/launch-readiness',
        component: MarketplaceLaunchReadinessComponent,
        canActivate: [permissionGuard],
        data: { requiredEntitlement: 'catalog', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'marketplace/global-commerce',
        component: GlobalCommerceAdminComponent,
        canActivate: [permissionGuard],
        data: { requiredEntitlement: 'catalog', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'marketplace/optimization',
        component: MarketplaceOptimizationAdminComponent,
        canActivate: [permissionGuard],
        data: { requiredEntitlement: 'catalog', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'marketplace/commission-rules',
        component: MarketplaceCommissionRulesComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'marketplace.seller.view', requiredEntitlement: 'catalog', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'marketplace/seller-tiers',
        component: MarketplaceSellerTiersComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'marketplace.seller.tier.manage', requiredEntitlement: 'catalog', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'marketplace/retail-media',
        component: MarketplaceRetailMediaComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'marketplace.retailmedia.view', requiredEntitlement: 'catalog', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'marketplace/sellers',
        component: MarketplaceSellersComponent,
        canActivate: [permissionGuard],
        data: { requiredEntitlement: 'catalog', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'marketplace/offering-proposals',
        component: MarketplaceOfferingProposalsComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'marketplace.seller.view', requiredEntitlement: 'catalog', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'marketplace/sellers/:id',
        component: MarketplaceSellerDetailComponent,
        canActivate: [permissionGuard],
        data: { requiredEntitlement: 'catalog', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'marketplace/storefront/stores',
        component: StorefrontStoreManagerComponent,
        canActivate: [permissionGuard],
        data: { requiredEntitlement: 'catalog', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'marketplace/storefront/publishing',
        component: StorefrontPublishingComponent,
        canActivate: [permissionGuard],
        data: { requiredEntitlement: 'catalog', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'marketplace/storefront/category-navigation',
        component: StorefrontCategoryNavigationManagerComponent,
        canActivate: [permissionGuard],
        data: { requiredEntitlement: 'catalog', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'marketplace/storefront/home-composer',
        component: StorefrontHomeComposerComponent,
        canActivate: [permissionGuard],
        data: { requiredEntitlement: 'catalog', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'marketplace/storefront/content-blocks',
        component: StorefrontContentBlockManagerComponent,
        canActivate: [permissionGuard],
        data: { requiredEntitlement: 'catalog', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'cmms/work-orders',
        component: CmmsWorkOrdersComponent,
        canActivate: [permissionGuard],
        data: { requiredEntitlement: 'catalog', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'cmms/work-orders/:id',
        component: CmmsWorkOrderDetailComponent,
        canActivate: [permissionGuard],
        data: { requiredEntitlement: 'catalog', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'cmms/downtime',
        component: CmmsDowntimeDashboardComponent,
        canActivate: [permissionGuard],
        data: { requiredEntitlement: 'catalog', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'cmms/plans',
        component: CmmsMaintenancePlansComponent,
        canActivate: [permissionGuard],
        data: { requiredEntitlement: 'catalog', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'event-hub/catalog',
        component: EventHubCatalogComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'eventhub.catalog', requiredScopes: ['admin'] }
      },
      {
        path: 'event-hub/catalog/:eventType/versions/:version',
        component: EventHubCatalogDetailComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'eventhub.catalog', requiredScopes: ['admin'] }
      },
      {
        path: 'event-hub/webhook-subscriptions',
        component: EventHubWebhookSubscriptionsComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'eventhub.subscriptions', requiredScopes: ['admin'] }
      },
      {
        path: 'event-hub/webhook-subscriptions/:id',
        component: EventHubWebhookSubscriptionDetailComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'eventhub.subscriptions', requiredScopes: ['admin'] }
      },
      {
        path: 'event-hub/observability',
        component: EventHubObservabilityComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'eventhub.observability', requiredScopes: ['admin'] }
      },
      {
        path: 'knowledge/sources',
        component: KnowledgeSourcesComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'knowledge.sources', requiredScopes: ['admin'] }
      },
      {
        path: 'knowledge/sources/:sourceId',
        component: KnowledgeSourceDetailComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'knowledge.sources', requiredScopes: ['admin'] }
      },
      {
        path: 'iot/devices',
        component: IoTDevicesComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'iot.devices', requiredScopes: ['admin'] }
      },
      {
        path: 'iot/devices/:deviceId',
        component: IoTDeviceDetailComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'iot.devices', requiredScopes: ['admin'] }
      },
      {
        path: 'workflow/definitions',
        component: WorkflowDefinitionsComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'workflow.definitions', requiredScopes: ['admin'] }
      },
      {
        path: 'workflow/definitions/:id',
        component: WorkflowDefinitionDetailComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'workflow.definitions', requiredScopes: ['admin'] }
      },
      {
        path: 'workflow/intents',
        component: WorkflowIntentOpsListComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'workflow.intents.ops', requiredScopes: ['admin'] }
      },
      {
        path: 'workflow/intents/new',
        component: WorkflowIntentCreateComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'workflow.intents', requiredScopes: ['admin'] }
      },
      {
        path: 'workflow/intents/governance',
        component: WorkflowIntentGovernanceComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'workflow.intents.discovery', requiredScopes: ['admin'] }
      },
      {
        path: 'workflow/intents/approvals/inbox',
        component: WorkflowIntentApprovalInboxComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'workflow.intents.approvals', requiredScopes: ['admin'] }
      },
      {
        path: 'workflow/intents/evaluation',
        component: WorkflowIntentEvaluationDashboardComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'workflow.intents.eval', requiredScopes: ['admin'] }
      },
      {
        path: 'workflow/intents/evaluation/simulation',
        component: WorkflowIntentSimulationRunComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'workflow.intents.eval', requiredScopes: ['admin'] }
      },
      {
        path: 'workflow/intents/evaluation/runs/:runId',
        component: WorkflowIntentEvaluationRunDetailComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'workflow.intents.eval', requiredScopes: ['admin'] }
      },
      {
        path: 'workflow/intents/:id',
        component: WorkflowIntentDetailComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'workflow.intents.ops', requiredScopes: ['admin'] }
      },
      {
        path: 'workflow/instances',
        component: WorkflowInstancesComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'workflow.instances', requiredScopes: ['admin'] }
      },
      {
        path: 'workflow/instances/:id',
        component: WorkflowInstanceDetailComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'workflow.instances', requiredScopes: ['admin'] }
      },
      {
        path: 'workflow/triggers',
        component: WorkflowTriggerSubscriptionsComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'workflow.triggers', requiredScopes: ['admin'] }
      },
      {
        path: 'workflow/hooks/bindings',
        component: WorkflowHookBindingsComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'workflow.hooks', requiredScopes: ['admin'] }
      },
      {
        path: 'workflow/tasks',
        component: WorkflowTasksEntryComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'workflow.tasks', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'workflow/tasks/:id',
        component: WorkflowTaskDetailEntryComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'workflow.tasks', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'workflow/forms',
        component: OrganizationAssignedFormsComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'workflow.tasks', requiredScopes: ['organization'] }
      },
      {
        path: 'workflow/forms/:slug',
        component: OrganizationFormFillComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'workflow.tasks', requiredScopes: ['organization'] }
      },
      {
        path: 'dynamic/records',
        component: OrganizationDynamicRecordsComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'dynamic.records', requiredScopes: ['organization'] }
      },
      {
        path: 'finance/overview',
        component: OrganizationFinanceOverviewComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'financial-core.capabilities', requiredScopes: ['organization'] }
      },
      {
        path: 'dynamic/forms',
        component: DynamicFormsComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'dynamic.forms', requiredScopes: ['admin'] }
      },
      {
        path: 'dynamic/forms/:id',
        component: DynamicFormDetailComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'dynamic.forms', requiredScopes: ['admin'] }
      },
      {
        path: 'dynamic/forms/:formId/submissions/:submissionId',
        component: DynamicFormSubmissionDetailComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'dynamic.form-submissions', requiredScopes: ['admin'] }
      },
      {
        path: 'dynamic/entities',
        component: DynamicEntitiesComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'dynamic.entities', requiredScopes: ['admin'] }
      },
      {
        path: 'dynamic/entities/:id',
        component: DynamicEntityDetailComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'dynamic.entities', requiredScopes: ['admin'] }
      },
      {
        path: 'dynamic/entities/:entityId/records',
        component: DynamicRecordsComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'dynamic.records', requiredScopes: ['admin'] }
      },
      {
        path: 'dynamic/migrations',
        component: DynamicMigrationsComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'dynamic.migrations', requiredScopes: ['admin'] }
      },
      {
        path: 'dynamic/migrations/:id',
        component: DynamicMigrationDetailComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'dynamic.migrations', requiredScopes: ['admin'] }
      },
      {
        path: 'dynamic/import-export',
        component: DynamicImportExportComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'dynamic.forms', requiredScopes: ['admin'] }
      },
      {
        path: 'dynamic/audit',
        component: DynamicAuditComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'dynamic.audit', requiredScopes: ['admin'] }
      },
      {
        path: 'dynamic/analytics',
        component: DynamicAnalyticsDashboardComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'dynamic.analytics', requiredScopes: ['admin'] }
      },
      {
        path: 'dynamic/storefront-catalog',
        component: StorefrontFormCatalogComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'dynamic.forms', requiredScopes: ['admin'] }
      },
      {
        path: 'financial/control-center',
        component: FinanceControlCenterComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'financial-core.capabilities', requiredScopes: ['admin'] }
      },
      {
        path: 'financial/control-center/capabilities',
        component: FinanceControlCenterCapabilitiesComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'financial-core.capabilities', requiredScopes: ['admin'] }
      },
      {
        path: 'financial/control-center/books',
        component: FinanceControlCenterBooksComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'financial-core.books.view', requiredScopes: ['admin'] }
      },
      {
        path: 'financial/control-center/funds',
        component: FinanceControlCenterFundsComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'financial-core.capabilities', requiredScopes: ['admin'] }
      },
      {
        path: 'financial/control-center/periods',
        component: FinanceControlCenterPeriodsComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'financial-core.periods.view', requiredScopes: ['admin'] }
      },
      {
        path: 'financial/control-center/accounting-basis',
        component: FinanceControlCenterAccountingBasisComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'financial-core.capabilities', requiredScopes: ['admin'] }
      },
      {
        path: 'financial/control-center/journal-policy',
        component: FinanceControlCenterJournalPolicyComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'financial-core.policies.view', requiredScopes: ['admin'] }
      },
      {
        path: 'financial/control-center/currencies',
        component: FinanceControlCenterCurrenciesComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'financial-core.consolidation', requiredScopes: ['admin'] }
      },
      {
        path: 'financial/control-center/currencies/:code',
        component: FinanceControlCenterCurrencyDetailComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'financial-core.consolidation', requiredScopes: ['admin'] }
      },
      {
        path: 'financial/control-center/currency-policies',
        component: FinanceControlCenterCurrencyPoliciesComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'financial-core.consolidation', requiredScopes: ['admin'] }
      },
      {
        path: 'financial/control-center/currency-policies/:id',
        component: FinanceControlCenterCurrencyPolicyDetailComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'financial-core.consolidation', requiredScopes: ['admin'] }
      },
      {
        path: 'financial/control-center/fx-rates',
        component: FinanceControlCenterFxRatesComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'financial-core.consolidation', requiredScopes: ['admin'] }
      },
      {
        path: 'financial/control-center/fx-rates/:id',
        component: FinanceControlCenterFxRateDetailComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'financial-core.consolidation', requiredScopes: ['admin'] }
      },
      {
        path: 'financial/budgets',
        component: FinanceBudgetsComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'financial-core.budgets', requiredScopes: ['admin'] }
      },
      {
        path: 'financial/reconciliation',
        component: FinanceReconciliationComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'financial-core.reconciliation', requiredScopes: ['admin'] }
      },
      {
        path: 'financial/consolidation',
        component: FinanceConsolidationComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'financial-core.consolidation', requiredScopes: ['admin'] }
      },
      {
        path: 'financial/semantic-metrics',
        component: FinanceSemanticMetricsComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'financial-core.semantic-layer', requiredScopes: ['admin'] }
      },
      {
        path: 'financial/ai-recommendations',
        component: FinanceAiRecommendationsComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'financial-core.ai-finance', requiredScopes: ['admin'] }
      },

      // Operational finance — active in Admin nav (accounting, treasury, fixed-asset sub-ledgers).
      {
        path: 'financial/payments/banks',
        component: FinanceBanksComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'payments.accounting-operational', requiredScopes: ['admin'] }
      },
      {
        path: 'financial/payments/banks/:bankId',
        component: FinanceBankDetailComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'payments.accounting-operational', requiredScopes: ['admin'] }
      },
      {
        path: 'financial/payments/cashboxes',
        component: FinanceCashboxesComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'payments.wallet', requiredScopes: ['admin'] }
      },
      {
        path: 'financial/payments/cashboxes/:cashboxId',
        component: FinanceCashboxDetailComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'payments.wallet', requiredScopes: ['admin'] }
      },
      {
        path: 'financial/payments/customers',
        component: FinanceCustomersComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'platform.tenants.manage', requiredScopes: ['admin'] }
      },
      {
        path: 'financial/payments/customers/:customerId',
        component: FinanceCustomerDetailComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'platform.tenants.manage', requiredScopes: ['admin'] }
      },
      {
        path: 'financial/payments/receipts',
        component: FinanceReceiptsComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'payments.accounting-operational', requiredScopes: ['admin'] }
      },
      {
        path: 'financial/payments/receipts/:receiptId',
        component: FinanceReceiptDetailComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'payments.accounting-operational', requiredScopes: ['admin'] }
      },
      {
        path: 'financial/payments/payouts',
        component: FinancePayoutsComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'payments.accounting-operational', requiredScopes: ['admin'] }
      },
      {
        path: 'financial/payments/payouts/:paymentRecordId',
        component: FinancePayoutDetailComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'payments.accounting-operational', requiredScopes: ['admin'] }
      },
      {
        path: 'financial/payments/daily-overview',
        component: FinancePaymentsDailyOverviewComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'payments.accounting-operational', requiredScopes: ['admin'] }
      },
      {
        path: 'financial/payments/reports/time-person-receipts',
        component: FinancePaymentsReportReceiptsComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'payments.accounting-operational', requiredScopes: ['admin'] }
      },
      {
        path: 'financial/payments/reports/time-person-payouts',
        component: FinancePaymentsReportPayoutsComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'payments.accounting-operational', requiredScopes: ['admin'] }
      },
      {
        path: 'financial/payments/reports/bank-cashbox',
        component: FinancePaymentsReportBankCashboxComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'payments.accounting-operational', requiredScopes: ['admin'] }
      },
      {
        path: 'financial/management/chart-of-accounts',
        component: FinanceChartOfAccountsComponent,
        canActivate: [permissionGuard],
        data: { titleKey: 'nav.management.chartOfAccounts', requiredPermission: 'financial-core.accounts', requiredScopes: ['admin'] }
      },
      {
        path: 'financial/management/journal-entry',
        component: FinanceJournalEntryComponent,
        canActivate: [permissionGuard],
        data: { titleKey: 'nav.management.journalEntry', requiredPermission: 'financial-core.journals', requiredScopes: ['admin'] }
      },
      {
        path: 'financial/management/journal-entry/create',
        component: FinanceJournalEntryComponent,
        canActivate: [permissionGuard],
        data: { titleKey: 'nav.management.journalEntry', createMode: true, requiredPermission: 'financial-core.journals', requiredScopes: ['admin'] }
      },
      {
        path: 'financial/management/journal-entry/:journalId/edit',
        component: FinanceJournalEntryComponent,
        canActivate: [permissionGuard],
        data: { titleKey: 'nav.management.journalEntry', editMode: true, requiredPermission: 'financial-core.journals', requiredScopes: ['admin'] }
      },
      {
        path: 'financial/management/accounting-review',
        component: FinanceAccountingReviewComponent,
        canActivate: [permissionGuard],
        data: { titleKey: 'nav.management.accountingReview', requiredPermission: 'financial-core.journals', requiredScopes: ['admin'] }
      },
      {
        path: 'financial/management/closing',
        component: FinanceJournalEntryComponent,
        canActivate: [permissionGuard],
        data: {
          titleKey: 'nav.management.closing',
          descriptionKey: 'finance.closing.description',
          fixedEntryType: 'closing',
          baseRoute: '/financial/management/closing',
          requiredPermission: 'financial-core.journals',
          requiredScopes: ['admin']
        }
      },
      {
        path: 'financial/management/closing/create',
        component: FinanceJournalEntryComponent,
        canActivate: [permissionGuard],
        data: {
          titleKey: 'nav.management.closing',
          descriptionKey: 'finance.closing.description',
          fixedEntryType: 'closing',
          baseRoute: '/financial/management/closing',
          createMode: true,
          requiredPermission: 'financial-core.journals',
          requiredScopes: ['admin']
        }
      },
      {
        path: 'financial/management/closing/:journalId/edit',
        component: FinanceJournalEntryComponent,
        canActivate: [permissionGuard],
        data: {
          titleKey: 'nav.management.closing',
          descriptionKey: 'finance.closing.description',
          fixedEntryType: 'closing',
          baseRoute: '/financial/management/closing',
          editMode: true,
          requiredPermission: 'financial-core.journals',
          requiredScopes: ['admin']
        }
      },
      {
        path: 'financial/management/opening',
        component: FinanceJournalEntryComponent,
        canActivate: [permissionGuard],
        data: {
          titleKey: 'nav.management.opening',
          descriptionKey: 'finance.opening.description',
          fixedEntryType: 'opening',
          baseRoute: '/financial/management/opening',
          requiredPermission: 'financial-core.journals',
          requiredScopes: ['admin']
        }
      },
      {
        path: 'financial/management/opening/create',
        component: FinanceJournalEntryComponent,
        canActivate: [permissionGuard],
        data: {
          titleKey: 'nav.management.opening',
          descriptionKey: 'finance.opening.description',
          fixedEntryType: 'opening',
          baseRoute: '/financial/management/opening',
          createMode: true,
          requiredPermission: 'financial-core.journals',
          requiredScopes: ['admin']
        }
      },
      {
        path: 'financial/management/opening/:journalId/edit',
        component: FinanceJournalEntryComponent,
        canActivate: [permissionGuard],
        data: {
          titleKey: 'nav.management.opening',
          descriptionKey: 'finance.opening.description',
          fixedEntryType: 'opening',
          baseRoute: '/financial/management/opening',
          editMode: true,
          requiredPermission: 'financial-core.journals',
          requiredScopes: ['admin']
        }
      },

      // Retired experimental /financial/* where launch-track equivalent exists (Phase 11.7) — hidden from nav.
      {
        path: 'financial/sales/invoices',
        component: FinanceInvoicesComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'payments.accounting-operational', requiredScopes: ['admin'] }
      },
      {
        path: 'financial/sales/offline-commerce',
        component: PlannedModulePlaceholderComponent,
        canActivate: [permissionGuard],
        data: { titleKey: 'nav.sales.offlineCommerce', requiredPermission: 'payments.accounting-operational', requiredScopes: ['admin'] }
      },
      {
        path: 'financial/sales/sales-review',
        component: PlannedModulePlaceholderComponent,
        canActivate: [permissionGuard],
        data: { titleKey: 'nav.sales.salesReview', requiredPermission: 'payments.accounting-operational', requiredScopes: ['admin'] }
      },
      {
        path: 'financial/sales/reports/summary',
        component: PlannedModulePlaceholderComponent,
        canActivate: [permissionGuard],
        data: { titleKey: 'nav.sales.reportSummary', requiredPermission: 'payments.accounting-operational', requiredScopes: ['admin'] }
      },
      {
        path: 'financial/sales/reports/low-stock',
        component: PlannedModulePlaceholderComponent,
        canActivate: [permissionGuard],
        data: { titleKey: 'nav.sales.reportLowStock', requiredPermission: 'payments.accounting-operational', requiredScopes: ['admin'] }
      },
      {
        path: 'financial/sales/reports/high-sales',
        component: PlannedModulePlaceholderComponent,
        canActivate: [permissionGuard],
        data: { titleKey: 'nav.sales.reportHighSales', requiredPermission: 'payments.accounting-operational', requiredScopes: ['admin'] }
      },
      {
        path: 'financial/sales/reports/purchased-items',
        component: PlannedModulePlaceholderComponent,
        canActivate: [permissionGuard],
        data: { titleKey: 'nav.sales.reportPurchasedItems', requiredPermission: 'payments.accounting-operational', requiredScopes: ['admin'] }
      },
      {
        path: 'financial/sales/reports/country-sales',
        component: PlannedModulePlaceholderComponent,
        canActivate: [permissionGuard],
        data: { titleKey: 'nav.sales.reportCountrySales', requiredPermission: 'payments.accounting-operational', requiredScopes: ['admin'] }
      },
      {
        path: 'financial/sales/reports/customers',
        component: PlannedModulePlaceholderComponent,
        canActivate: [permissionGuard],
        data: { titleKey: 'nav.sales.reportCustomers', requiredPermission: 'payments.accounting-operational', requiredScopes: ['admin'] }
      },
      {
        path: 'financial/lending/configuration',
        component: PlannedModulePlaceholderComponent,
        canActivate: [permissionGuard],
        data: { titleKey: 'nav.lending.configuration', requiredPermission: 'payments.lending', requiredScopes: ['admin'] }
      },
      {
        path: 'financial/lending/interest-categories',
        component: PlannedModulePlaceholderComponent,
        canActivate: [permissionGuard],
        data: { titleKey: 'nav.lending.interestCategories', requiredPermission: 'payments.lending', requiredScopes: ['admin'] }
      },
      {
        path: 'financial/lending/suppliers',
        component: PlannedModulePlaceholderComponent,
        canActivate: [permissionGuard],
        data: { titleKey: 'nav.lending.suppliers', requiredPermission: 'payments.lending', requiredScopes: ['admin'] }
      },
      {
        path: 'financial/lending/investors',
        component: PlannedModulePlaceholderComponent,
        canActivate: [permissionGuard],
        data: { titleKey: 'nav.lending.investors', requiredPermission: 'payments.lending', requiredScopes: ['admin'] }
      },
      {
        path: 'financial/lending/customer-credit-profiles',
        component: PlannedModulePlaceholderComponent,
        canActivate: [permissionGuard],
        data: { titleKey: 'nav.lending.customerCreditProfiles', requiredPermission: 'payments.lending', requiredScopes: ['admin'] }
      },
      {
        path: 'financial/lending/loans',
        component: PaymentsLendingComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'payments.lending', requiredScopes: ['admin'] }
      },
      {
        path: 'financial/lending/installments',
        component: PlannedModulePlaceholderComponent,
        canActivate: [permissionGuard],
        data: { titleKey: 'nav.lending.installments', requiredPermission: 'payments.lending', requiredScopes: ['admin'] }
      },
      {
        path: 'financial/lending/salary-deductions',
        component: PlannedModulePlaceholderComponent,
        canActivate: [permissionGuard],
        data: { titleKey: 'nav.lending.salaryDeductions', requiredPermission: 'payments.lending', requiredScopes: ['admin'] }
      },
      {
        path: 'financial/lending/payroll-partnership',
        component: PlannedModulePlaceholderComponent,
        canActivate: [permissionGuard],
        data: { titleKey: 'nav.lending.payrollPartnership', requiredPermission: 'payments.lending', requiredScopes: ['admin'] }
      },
      {
        path: 'financial/lending/send-deductions',
        component: PlannedModulePlaceholderComponent,
        canActivate: [permissionGuard],
        data: { titleKey: 'nav.lending.sendDeductions', requiredPermission: 'payments.lending', requiredScopes: ['admin'] }
      },
      {
        path: 'financial/lending/accounting-match',
        component: PlannedModulePlaceholderComponent,
        canActivate: [permissionGuard],
        data: { titleKey: 'nav.lending.accountingMatch', requiredPermission: 'payments.lending', requiredScopes: ['admin'] }
      },
      {
        path: 'financial/transactions/fin',
        component: PaymentsIntentsComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'payments.intents', requiredScopes: ['admin'] }
      },
      {
        path: 'financial/transactions/lend',
        component: PaymentsLendingComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'payments.lending', requiredScopes: ['admin'] }
      },
      {
        path: 'financial/transactions/wallet',
        component: PaymentsWalletComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'payments.wallet', requiredScopes: ['admin'] }
      },
      {
        path: 'financial/transactions/ai-fin-suite',
        component: FinanceAiRecommendationsComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'financial-core.ai-finance', requiredScopes: ['admin'] }
      },
      {
        path: 'financial/assets/register',
        component: PlannedModulePlaceholderComponent,
        canActivate: [permissionGuard],
        data: { titleKey: 'nav.assets.register', requiredPermission: 'financial-core.capabilities', requiredScopes: ['admin'] }
      },
      {
        path: 'financial/assets/groups',
        component: PlannedModulePlaceholderComponent,
        canActivate: [permissionGuard],
        data: { titleKey: 'nav.assets.groups', requiredPermission: 'financial-core.capabilities', requiredScopes: ['admin'] }
      },
      {
        path: 'financial/assets/depreciation',
        component: PlannedModulePlaceholderComponent,
        canActivate: [permissionGuard],
        data: { titleKey: 'nav.assets.depreciation', requiredPermission: 'financial-core.capabilities', requiredScopes: ['admin'] }
      },
      {
        path: 'financial/assets/revaluation',
        component: PlannedModulePlaceholderComponent,
        canActivate: [permissionGuard],
        data: { titleKey: 'nav.assets.revaluation', requiredPermission: 'financial-core.capabilities', requiredScopes: ['admin'] }
      },
      {
        path: 'financial/assets/ledger',
        component: PlannedModulePlaceholderComponent,
        canActivate: [permissionGuard],
        data: { titleKey: 'nav.assets.ledger', requiredPermission: 'financial-core.capabilities', requiredScopes: ['admin'] }
      },
      {
        path: 'financial/assets/settings',
        component: PlannedModulePlaceholderComponent,
        canActivate: [permissionGuard],
        data: { titleKey: 'nav.assets.settings', requiredPermission: 'financial-core.capabilities', requiredScopes: ['admin'] }
      },
      {
        path: 'insurance',
        pathMatch: 'full',
        redirectTo: 'insurance/policies'
      },
      {
        path: 'insurance/policies',
        component: InsuranceShellComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'insurance.policies.view', requiredEntitlement: 'insurance.core', requiredScopes: ['admin'] }
      },
      {
        path: 'insurance/products',
        component: InsuranceProductsShellComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'insurance.products.view', requiredEntitlement: 'insurance.core', requiredScopes: ['admin'] }
      },
      {
        path: 'insurance/print-templates',
        component: InsurancePrintTemplatesManagementComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'insurance.products.view', requiredEntitlement: 'insurance.core', requiredScopes: ['admin'] }
      },
      {
        path: 'insurance/product-versions',
        component: InsuranceProductVersionsShellComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'insurance.products.view', requiredEntitlement: 'insurance.core', requiredScopes: ['admin'] }
      },
      {
        path: 'insurance/products/new',
        component: InsuranceProductDetailComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'insurance.products.create', requiredEntitlement: 'insurance.core', requiredScopes: ['admin'] }
      },
      {
        path: 'insurance/products/:productId',
        component: InsuranceProductDetailComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'insurance.products.view', requiredEntitlement: 'insurance.core', requiredScopes: ['admin'] }
      },
      {
        path: 'insurance/products/:productId/versions/new',
        component: InsuranceProductVersionDetailComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'insurance.products.create', requiredEntitlement: 'insurance.core', requiredScopes: ['admin'] }
      },
      {
        path: 'insurance/products/:productId/versions/:versionId',
        component: InsuranceProductVersionDetailComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'insurance.products.view', requiredEntitlement: 'insurance.core', requiredScopes: ['admin'] }
      },
      {
        path: 'insurance/rating',
        component: InsuranceRatingPlansComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'insurance.products.view', requiredEntitlement: 'insurance.core', requiredScopes: ['admin'] }
      },
      {
        path: 'insurance/rating/new',
        component: InsuranceRatingPlanDetailComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'insurance.products.create', requiredEntitlement: 'insurance.core', requiredScopes: ['admin'] }
      },
      {
        path: 'insurance/rating/:ratingPlanId',
        component: InsuranceRatingPlanDetailComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'insurance.products.view', requiredEntitlement: 'insurance.core', requiredScopes: ['admin'] }
      },
      {
        path: 'insurance/quotes',
        component: InsuranceQuoteWorkbenchComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'insurance.quotes.view', requiredEntitlement: 'insurance.core', requiredScopes: ['admin'] }
      },
      {
        path: 'insurance/quotes/new',
        component: InsuranceQuoteDetailComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'insurance.quotes.create', requiredEntitlement: 'insurance.core', requiredScopes: ['admin'] }
      },
      {
        path: 'insurance/quotes/:quoteId',
        component: InsuranceQuoteDetailComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'insurance.quotes.view', requiredEntitlement: 'insurance.core', requiredScopes: ['admin'] }
      },
      {
        path: 'insurance/proposals',
        component: InsuranceProposalDeskComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'insurance.proposals.view', requiredEntitlement: 'insurance.core', requiredScopes: ['admin'] }
      },
      {
        path: 'insurance/proposals/:proposalId',
        component: InsuranceProposalDetailComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'insurance.proposals.view', requiredEntitlement: 'insurance.core', requiredScopes: ['admin'] }
      },
      {
        path: 'insurance/uw-cases',
        component: InsuranceUwInboxComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'insurance.uw.view', requiredEntitlement: 'insurance.core', requiredScopes: ['admin'] }
      },
      {
        path: 'insurance/uw-cases/:uwCaseId',
        component: InsuranceUwCaseDetailComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'insurance.uw.view', requiredEntitlement: 'insurance.core', requiredScopes: ['admin'] }
      },
      {
        path: 'insurance/claims',
        component: InsuranceClaimsShellComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'insurance.claims.view', requiredEntitlement: 'insurance.core', requiredScopes: ['admin'] }
      },
      {
        path: 'insurance/health/providers',
        component: InsuranceHealthProvidersShellComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'insurance.health.view', requiredEntitlement: 'insurance.health', requiredScopes: ['admin'] }
      },
      {
        path: 'insurance/health/providers/new',
        component: InsuranceHealthProviderDetailComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'insurance.health.create', requiredEntitlement: 'insurance.health', requiredScopes: ['admin'] }
      },
      {
        path: 'insurance/health/providers/:providerId',
        component: InsuranceHealthProviderDetailComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'insurance.health.view', requiredEntitlement: 'insurance.health', requiredScopes: ['admin'] }
      },
      {
        path: 'insurance/master-policies',
        component: InsuranceMasterPoliciesShellComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'insurance.group.view', requiredEntitlement: 'insurance.group', requiredScopes: ['admin'] }
      },
      {
        path: 'insurance/master-policies/new',
        component: InsuranceMasterPolicyDetailComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'insurance.group.create', requiredEntitlement: 'insurance.group', requiredScopes: ['admin'] }
      },
      {
        path: 'insurance/master-policies/:masterPolicyId',
        component: InsuranceMasterPolicyDetailComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'insurance.group.view', requiredEntitlement: 'insurance.group', requiredScopes: ['admin'] }
      },
      {
        path: 'insurance/reinsurance/treaties',
        component: InsuranceReinsuranceTreatiesShellComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'insurance.reinsurance.view', requiredEntitlement: 'insurance.reinsurance', requiredScopes: ['admin'] }
      },
      {
        path: 'insurance/reinsurance/treaties/new',
        component: InsuranceReinsuranceTreatyDetailComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'insurance.reinsurance.create', requiredEntitlement: 'insurance.reinsurance', requiredScopes: ['admin'] }
      },
      {
        path: 'insurance/reinsurance/treaties/:treatyId',
        component: InsuranceReinsuranceTreatyDetailComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'insurance.reinsurance.view', requiredEntitlement: 'insurance.reinsurance', requiredScopes: ['admin'] }
      },
      {
        path: 'insurance/regulatory/jobs',
        component: InsuranceRegulatoryJobsShellComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'insurance.regulatory.view', requiredEntitlement: 'insurance.regulatory.iran', requiredScopes: ['admin'] }
      },
      {
        path: 'insurance/regulatory/jobs/:jobId',
        component: InsuranceRegulatoryJobDetailComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'insurance.regulatory.view', requiredEntitlement: 'insurance.regulatory.iran', requiredScopes: ['admin'] }
      },
      {
        path: 'insurance/ai-recommendations',
        component: InsuranceAiRecommendationsComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'insurance.ai.view', requiredEntitlement: 'insurance.ai', requiredScopes: ['admin'] }
      },
      {
        path: 'insurance/ai-recommendations/:recommendationId',
        component: InsuranceAiRecommendationDetailComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'insurance.ai.view', requiredEntitlement: 'insurance.ai', requiredScopes: ['admin'] }
      },
      {
        path: 'insurance/producers',
        component: InsuranceProducersShellComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'insurance.distribution.view', requiredEntitlement: 'insurance.core', requiredScopes: ['admin'] }
      },
      {
        path: 'insurance/producers/new',
        component: InsuranceProducerDetailComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'insurance.distribution.create', requiredEntitlement: 'insurance.core', requiredScopes: ['admin'] }
      },
      {
        path: 'insurance/producers/:producerId',
        component: InsuranceProducerDetailComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'insurance.distribution.view', requiredEntitlement: 'insurance.core', requiredScopes: ['admin'] }
      },
      {
        path: 'insurance/distribution',
        component: InsuranceDistributionAdminComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'insurance.distribution.view', requiredEntitlement: 'insurance.core', requiredScopes: ['admin'] }
      },
      {
        path: 'insurance/commission-plans',
        component: InsuranceCommissionPlansComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'insurance.commissions.view', requiredEntitlement: 'insurance.core', requiredScopes: ['admin'] }
      },
      {
        path: 'insurance/commission-plans/new',
        component: InsuranceCommissionPlanDetailComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'insurance.commissions.create', requiredEntitlement: 'insurance.core', requiredScopes: ['admin'] }
      },
      {
        path: 'insurance/commission-plans/:planId',
        component: InsuranceCommissionPlanDetailComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'insurance.commissions.view', requiredEntitlement: 'insurance.core', requiredScopes: ['admin'] }
      },
      {
        path: 'insurance/commission-accruals',
        component: InsuranceCommissionAccrualsComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'insurance.commissions.view', requiredEntitlement: 'insurance.core', requiredScopes: ['admin'] }
      },
      {
        path: 'insurance/commission-settlements',
        component: InsuranceCommissionSettlementsComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'insurance.commissions.view', requiredEntitlement: 'insurance.core', requiredScopes: ['admin'] }
      },
      {
        path: 'insurance/commission-settlements/new',
        component: InsuranceCommissionSettlementDetailComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'insurance.commissions.create', requiredEntitlement: 'insurance.core', requiredScopes: ['admin'] }
      },
      {
        path: 'insurance/commission-settlements/:settlementId',
        component: InsuranceCommissionSettlementDetailComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'insurance.commissions.view', requiredEntitlement: 'insurance.core', requiredScopes: ['admin'] }
      },
      {
        path: 'insurance/premium-invoices',
        component: InsurancePremiumInvoicesComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'insurance.premiums.view', requiredEntitlement: 'insurance.core', requiredScopes: ['admin'] }
      },
      {
        path: 'insurance/premium-invoices/:invoiceId',
        component: InsurancePremiumInvoiceDetailComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'insurance.premiums.view', requiredEntitlement: 'insurance.core', requiredScopes: ['admin'] }
      },
      {
        path: 'insurance/claims/new',
        component: InsuranceClaimDetailComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'insurance.claims.view', requiredEntitlement: 'insurance.core', requiredScopes: ['admin'] }
      },
      {
        path: 'insurance/claims/:claimId',
        component: InsuranceClaimDetailComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'insurance.claims.view', requiredEntitlement: 'insurance.core', requiredScopes: ['admin'] }
      },
      {
        path: 'insurance/policies/new',
        component: InsurancePolicyDetailComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'insurance.policies.create', requiredEntitlement: 'insurance.core', requiredScopes: ['admin'] }
      },
      {
        path: 'insurance/policies/:policyId',
        component: InsurancePolicyDetailComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'insurance.policies.view', requiredEntitlement: 'insurance.core', requiredScopes: ['admin'] }
      },
      {
        path: 'growth/crm/leads',
        component: GrowthLeadsComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'growth.crm.view', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'growth/crm/leads/new',
        component: GrowthLeadDetailComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'growth.crm.view', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'growth/crm/leads/:leadId',
        component: GrowthLeadDetailComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'growth.crm.view', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'growth/crm/segments',
        component: GrowthSegmentsComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'growth.crm.view', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'growth/crm/customer-360',
        component: GrowthCustomer360Component,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'growth.crm.view', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'growth/consent/preference-center',
        component: GrowthConsentPreferenceCenterComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'growth.comms.view', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'growth/tenant-config',
        component: GrowthTenantConfigComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'growth.admin.manage', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'growth/comms/channels',
        component: GrowthCommsChannelsComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'growth.comms.view', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'growth/comms/social-posts',
        component: GrowthSocialPostsComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'growth.marketing.social.manage', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'growth/marketing/campaigns',
        component: GrowthMarketingCampaignsComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'growth.marketing.view', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'growth/marketing/campaigns/new',
        component: GrowthMarketingCampaignDetailComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'growth.marketing.view', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'growth/marketing/campaigns/:campaignId',
        component: GrowthMarketingCampaignDetailComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'growth.marketing.view', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'growth/marketing/content-assets/new',
        component: GrowthContentAssetDetailComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'growth.marketing.view', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'growth/marketing/content-assets/:contentId',
        component: GrowthContentAssetDetailComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'growth.marketing.view', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'growth/marketing/content-calendar',
        component: GrowthContentCalendarComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'growth.marketing.view', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'growth/marketing/approval-queue',
        component: GrowthContentReviewQueueComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'growth.marketing.approve', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'growth/analytics/revops-dashboard',
        component: GrowthIntelligenceDashboardComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'growth.intelligence.view', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'growth/intelligence/attribution',
        component: GrowthAttributionComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'growth.intelligence.view', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'growth/intelligence/funnels',
        component: GrowthFunnelsComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'growth.intelligence.view', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'growth/intelligence/cohorts',
        component: GrowthCohortsComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'growth.intelligence.view', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'growth/intelligence/scores',
        component: GrowthScoresComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'growth.intelligence.view', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'growth/intelligence/forecasts',
        component: GrowthForecastComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'growth.intelligence.run', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'growth/intelligence/content-performance',
        component: GrowthContentPerformanceComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'growth.intelligence.content.view', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'growth/optimizer/console',
        component: GrowthOptimizerConsoleComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'growth.optimization.view', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'growth/optimizer/optimization-runs',
        component: GrowthOptimizerRunsComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'growth.optimization.view', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'growth/optimizer/runs/:runId',
        component: GrowthOptimizerRunDetailComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'growth.optimization.view', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'growth/optimizer/guardrails',
        component: GrowthOptimizerGuardrailsComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'growth.optimization.guardrails.manage', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'growth/optimizer/automation',
        component: GrowthOptimizerAutomationComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'growth.optimization.manage', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'growth/twin/business-twin',
        component: GrowthBusinessTwinComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'growth.twin.view', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'growth/twin/scenarios',
        component: GrowthTwinScenariosComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'growth.twin.view', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'growth/twin/scenarios/new',
        component: GrowthTwinScenarioDetailComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'growth.twin.manage', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'growth/twin/scenarios/:scenarioId',
        component: GrowthTwinScenarioDetailComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'growth.twin.view', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'growth/service/success-plans',
        component: GrowthSuccessPlansComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'growth.service.view', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'growth/service/success-plans/new',
        component: GrowthSuccessPlanDetailComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'growth.service.manage', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'growth/service/success-plans/:planId',
        component: GrowthSuccessPlanDetailComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'growth.service.view', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'growth/service/retention-plays',
        component: GrowthRetentionPlaysComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'growth.service.view', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'growth/service/retention-plays/new',
        component: GrowthRetentionPlayDetailComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'growth.service.manage', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'growth/service/retention-plays/:playId',
        component: GrowthRetentionPlayDetailComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'growth.service.view', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'growth/marketplace/listings',
        component: GrowthAgentMarketplaceListingsComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'growth.marketplace.view', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'growth/marketplace/listings/:listingKey',
        component: GrowthAgentMarketplaceListingDetailComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'growth.marketplace.view', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'growth/marketplace/agent-installs',
        component: GrowthAgentMarketplaceInstallsComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'growth.marketplace.view', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'growth/marketplace/agent-installs/:installId',
        component: GrowthAgentMarketplaceInstallDetailComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'growth.marketplace.view', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'growth/marketplace/installs',
        component: GrowthIndustryPacksComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'growth.industry.view', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'growth/marketplace/installs/:packKey',
        component: GrowthIndustryPackDetailComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'growth.industry.view', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'growth/marketplace/bindings',
        component: GrowthIndustryBindingsComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'growth.industry.view', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'growth/marketplace/bindings/new',
        component: GrowthIndustryBindingDetailComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'growth.industry.view', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'growth/marketplace/bindings/:bindingId',
        component: GrowthIndustryBindingDetailComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'growth.industry.view', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'growth/integration/connectors',
        component: GrowthIntegrationConnectorsComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'growth.integration.view', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'growth/integration/connectors/:connectorKey',
        component: GrowthIntegrationConnectorDetailComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'growth.integration.view', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'growth/integration/sync-status',
        component: GrowthIntegrationSyncStatusComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'growth.integration.view', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'growth/paid-media/accounts',
        component: GrowthPaidMediaAccountsComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'growth.paidmedia.view', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'growth/paid-media/accounts/:accountId',
        component: GrowthPaidMediaAccountDetailComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'growth.paidmedia.view', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'growth/paid-media/campaign-links',
        component: GrowthPaidMediaCampaignLinksComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'growth.paidmedia.view', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'growth/paid-media/campaign-links/:linkId',
        component: GrowthPaidMediaCampaignLinkDetailComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'growth.paidmedia.view', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'growth/paid-media/audience-sync',
        component: GrowthPaidMediaAudienceSyncComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'growth.paidmedia.view', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'growth/paid-media/roas',
        component: GrowthPaidMediaRoasComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'growth.paidmedia.view', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'growth/marketing/ace-studio',
        component: GrowthAceContentStudioComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'growth.content.ace.view', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'growth/marketing/ace-studio/briefs/new',
        component: GrowthAceBriefDetailComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'growth.content.ace.view', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'growth/marketing/ace-studio/briefs/:briefId',
        component: GrowthAceBriefDetailComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'growth.content.ace.view', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'growth/marketing/article-publishing',
        component: GrowthArticlePublishingListComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'growth.marketing.view', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'growth/marketing/article-publishing/:contentId',
        component: GrowthArticlePublishingDetailComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'growth.marketing.view', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'growth/business-plan',
        redirectTo: 'growth/agents/strategy-artifacts',
        pathMatch: 'full'
      },
      {
        path: 'growth/marketing-plan',
        redirectTo: 'growth/agents/strategy-artifacts',
        pathMatch: 'full'
      },
      {
        path: 'growth/strategy/business-plan',
        redirectTo: 'growth/agents/strategy-artifacts',
        pathMatch: 'full'
      },
      {
        path: 'growth/strategy/marketing-plan',
        redirectTo: 'growth/agents/strategy-artifacts',
        pathMatch: 'full'
      },
      {
        path: 'growth/agents/definitions',
        component: GrowthAgentConsoleComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'growth.agents.view', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'growth/agents/recommendations',
        component: GrowthAgentRecommendationsComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'growth.agents.view', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'growth/agents/recommendations/:id',
        component: GrowthAgentRecommendationDetailComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'growth.agents.view', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'growth/agents/approval-queue',
        component: GrowthAgentApprovalQueueComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'growth.agents.approve', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'growth/agents/runs/:id',
        component: GrowthAgentRunDetailComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'growth.agents.view', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'growth/agents/guardrails',
        component: GrowthAgentGuardrailsComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'growth.agents.manage', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'growth/agents/workflow-bindings',
        component: GrowthAgentWorkflowBindingsComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'growth.agents.manage', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'growth/agents/strategy-artifacts',
        component: GrowthStrategyArtifactsComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'growth.strategy.view', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'growth/agents/strategy-artifacts/new',
        component: GrowthStrategyArtifactDetailComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'growth.strategy.view', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'growth/agents/strategy-artifacts/:id',
        component: GrowthStrategyArtifactDetailComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'growth.strategy.view', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'growth/strategy/activation-plans',
        component: GrowthStrategyActivationPlansComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'growth.strategy.view', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'growth/strategy/activation-plans/new',
        component: GrowthStrategyActivationPlanDetailComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'growth.strategy.view', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'growth/strategy/activation-plans/:activationPlanId',
        component: GrowthStrategyActivationPlanDetailComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'growth.strategy.view', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'growth/journey/discoveries',
        component: GrowthBusinessDiscoveryListComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'growth.journey.discovery.read', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'growth/journey/discoveries/new',
        component: GrowthBusinessDiscoveryDetailComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'growth.journey.discovery.write', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'growth/journey/discoveries/:discoveryId',
        component: GrowthBusinessDiscoveryDetailComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'growth.journey.discovery.read', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'growth/journey/journeys',
        component: GrowthJourneyListComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'growth.journey.discovery.read', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'growth/journey/journeys/:journeyId',
        component: GrowthJourneyDashboardComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'growth.journey.discovery.read', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'growth/journey/brand-voice-profiles',
        component: GrowthBrandVoiceListComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'growth.journey.brandVoice.read', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'growth/journey/brand-voice-profiles/new',
        component: GrowthBrandVoiceDetailComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'growth.journey.brandVoice.write', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'growth/journey/brand-voice-profiles/:profileId',
        component: GrowthBrandVoiceDetailComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'growth.journey.brandVoice.read', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'growth/journey/swot-factors',
        component: GrowthSwotFactorCatalogComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'growth.journey.swot.generate', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'growth/marketing/publish-operations',
        component: GrowthPublishOperationsComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'growth.marketing.view', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'growth/concierge',
        component: GrowthTgeConciergeComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'growth.tge.view', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'growth/search-ops',
        component: GrowthSearchOpsWorkHomeComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'growth.searchops.view', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'growth/search-ops/properties',
        component: GrowthSearchOpsPropertiesComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'growth.searchops.view', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'growth/search-ops/properties/:id',
        component: GrowthSearchOpsPropertyDetailComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'growth.searchops.view', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'growth/search-ops/backlog',
        component: GrowthSearchOpsBacklogComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'growth.searchops.view', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'growth/search-ops/coworkers',
        component: GrowthSearchOpsCoworkersComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'growth.searchops.view', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'growth/search-ops/keywords',
        component: GrowthSearchOpsKeywordsComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'growth.searchops.view', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'growth/search-ops/urls',
        component: GrowthSearchOpsUrlsComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'growth.searchops.view', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'growth/search-ops/issues',
        component: GrowthSearchOpsIssuesComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'growth.searchops.view', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'growth/search-ops/redirects',
        component: GrowthSearchOpsRedirectsComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'growth.searchops.view', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'growth/search-ops/apply-queue',
        component: GrowthSearchOpsApplyQueueComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'growth.searchops.apply', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'growth/search-ops/offpage',
        component: GrowthSearchOpsOffpageComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'growth.searchops.view', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'growth/search-ops/local',
        component: GrowthSearchOpsLocalComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'growth.searchops.view', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'growth/search-ops/sem',
        component: GrowthSearchOpsSemComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'growth.searchops.view', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'growth/search-ops/scorecard',
        component: GrowthSearchOpsScorecardComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'growth.searchops.view', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'growth/search-ops/reports',
        component: GrowthSearchOpsReportsComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'growth.searchops.view', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'growth/seo/profiles',
        component: GrowthSeoProfilesComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'growth.search.view', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'growth/seo/profiles/:id',
        component: GrowthSeoProfilesComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'growth.search.view', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'growth/aeo/answers',
        component: GrowthAeoAnswersComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'growth.search.view', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'growth/sxo/experiments',
        component: GrowthSxoExperimentsComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'growth.search.view', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'growth/search/geo/profiles',
        component: GrowthGeoProfilesComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'growth.search.view', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'growth/comms/distributions',
        component: GrowthCommsDistributionComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'growth.comms.distribution.view', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'growth/comms/distributions/:runId',
        component: GrowthCommsDistributionDetailComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'growth.comms.distribution.view', requiredScopes: ['admin', 'organization'] }
      },
      {
        path: 'notifications/messages',
        component: NotificationsMessagesComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'notifications.logs.view', requiredScopes: ['admin'] }
      },
      {
        path: 'notifications/messages/:messageId',
        component: NotificationsMessageDetailComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'notifications.logs.view', requiredScopes: ['admin'] }
      },
      {
        path: 'notifications/templates',
        component: NotificationsTemplatesComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'notifications.templates.view', requiredScopes: ['admin'] }
      },
      {
        path: 'notifications/templates/:templateId',
        component: NotificationsTemplateDetailComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'notifications.templates.view', requiredScopes: ['admin'] }
      },
      {
        path: 'notifications/providers',
        component: NotificationsProvidersComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'notifications.providers.view', requiredScopes: ['admin'] }
      },
      {
        path: 'notifications/providers/:providerId',
        component: NotificationsProvidersComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'notifications.providers.view', requiredScopes: ['admin'] }
      },
      {
        path: 'notifications/delivery',
        component: NotificationsDeliveryComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'notifications.delivery.view', requiredScopes: ['admin'] }
      },
      {
        path: 'notifications/policy',
        component: NotificationsPolicyComponent,
        canActivate: [permissionGuard],
        data: { requiredPermission: 'notifications.policy.view', requiredScopes: ['admin'] }
      },
      {
        path: 'notifications/channels',
        redirectTo: 'notifications/providers',
        pathMatch: 'full'
      },
      ...COMMS_REDIRECT_ROUTES,
      ...COMMS_ROUTES,
      ...GRC_ROUTES,
      ...FCC_ROUTES,
      ...buildPlaceholderRoutes(PLACEHOLDER_SCREEN_DEFS)
    ]
  },
  { path: '**', redirectTo: 'dashboard' }
];
